var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSalesC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 643.06 350.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{isolation:isolate;}.cls-3{fill:#e5f4fb;}.cls-4,.cls-64{fill:#fff;}.cls-5{fill:#f5fbfd;}.cls-6{fill:#8ad3f6;}.cls-46,.cls-50,.cls-54,.cls-6,.cls-72,.cls-75,.cls-76{opacity:0.5;}.cls-7{fill:#d8d8f0;}.cls-8{fill:#9d9dda;}.cls-9{fill:#8484d1;}.cls-10{fill:#2d4851;}.cls-11{fill:#576d74;}.cls-12{fill:#b73d6f;}.cls-13{fill:#cdecf9;}.cls-14{fill:#a3c9e8;}.cls-15{fill:#798a90;}.cls-16{fill:#415257;}.cls-17{fill:#c8dff1;}.cls-18{fill:#d7f0fa;}.cls-19{fill:#adc975;}.cls-20{fill:#864052;}.cls-21{fill:#8080ba;}.cls-22{fill:#8d8dce;}.cls-23{fill:#ff9e80;}.cls-24{fill:#4d545d;}.cls-25,.cls-46{fill:#3a3f46;}.cls-26{fill:#71767d;}.cls-27{fill:#9898d3;}.cls-28{fill:#ffbd99;}.cls-29{fill:#663d49;}.cls-30{fill:#4d2e37;}.cls-31{fill:#754656;}.cls-32{fill:#8e445a;}.cls-33{fill:#6b3344;}.cls-33,.cls-59,.cls-64{opacity:0.25;}.cls-34{fill:#ea6b53;}.cls-35{fill:#f78659;}.cls-36{fill:#f9a973;}.cls-37{fill:#ffb98a;}.cls-38{fill:#f78663;}.cls-39,.cls-50,.cls-52{fill:#eee;}.cls-40{fill:#d6e1e5;}.cls-41{fill:#f7f7f7;}.cls-42{fill:#91ba61;}.cls-43{fill:#5e809b;}.cls-44{fill:#504132;}.cls-45{fill:#b0bccc;}.cls-47{fill:#7b90aa;}.cls-48{fill:#ffc49c;}.cls-49,.cls-54{fill:#3e4751;}.cls-51,.cls-75,.cls-76{fill:#8ebddd;}.cls-52,.cls-53{opacity:0.75;}.cls-53{fill:#ffa466;}.cls-55{fill:#29424c;}.cls-56{fill:#ffcaad;}.cls-57{fill:#c5a3ac;}.cls-58{fill:#b68c97;}.cls-59,.cls-60{fill:#9e6675;}.cls-61{fill:#dcc8cd;}.cls-62{fill:#65303e;}.cls-63{fill:#1f3239;}.cls-65{clip-path:url(#clip-path);}.cls-66{fill:#e2b1c5;}.cls-67{fill:#892e53;}.cls-68{fill:#a82a5e;}.cls-69,.cls-72{fill:#373b41;}.cls-70{fill:#494f56;}.cls-71{fill:#585f68;}.cls-73{fill:#603043;}.cls-74{fill:#ebf7fd;}.cls-75{mix-blend-mode:multiply;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-39.95 -24.95)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M257,181.85l3.25,2.44v8.11c-6.53,5.47-12.77,16.57-15.84,29.37-4.39,18.26-.69,33.06,8.25,33.07,6.79,0,14.66-8.54,20-20.66h66.35V181.85Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2.7,
    y: 0.31,
    width: 197.01,
    height: 52.66,
    rx: 10.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M126.94,40.17H54.86a2.74,2.74,0,0,1-2.74-2.74h0a2.74,2.74,0,0,1,2.74-2.74h72.08a2.74,2.74,0,0,1,2.74,2.74h0A2.74,2.74,0,0,1,126.94,40.17Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M230.75,40.17H149.18a2.74,2.74,0,0,1-2.74-2.74h0a2.74,2.74,0,0,1,2.74-2.74h81.57a2.74,2.74,0,0,1,2.74,2.74h0A2.74,2.74,0,0,1,230.75,40.17Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M80.94,54.33H54.86a2.74,2.74,0,0,1-2.74-2.74h0a2.74,2.74,0,0,1,2.74-2.74H80.94a2.74,2.74,0,0,1,2.74,2.74h0A2.74,2.74,0,0,1,80.94,54.33Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M156.15,54.33H95.87a2.75,2.75,0,0,1-2.75-2.74h0a2.74,2.74,0,0,1,2.75-2.74h60.28a2.73,2.73,0,0,1,2.74,2.74h0A2.74,2.74,0,0,1,156.15,54.33Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M230.28,54.33H167.17a2.74,2.74,0,0,1-2.74-2.74h0a2.74,2.74,0,0,1,2.74-2.74h63.11A2.74,2.74,0,0,1,233,51.59h0A2.75,2.75,0,0,1,230.28,54.33Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M104,68.49H54.86a2.74,2.74,0,0,1-2.74-2.74h0A2.74,2.74,0,0,1,54.86,63H104a2.74,2.74,0,0,1,2.74,2.74h0A2.74,2.74,0,0,1,104,68.49Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M229.47,68.49H139.64a2.75,2.75,0,0,1-2.75-2.74h0A2.74,2.74,0,0,1,139.64,63h89.83a2.74,2.74,0,0,1,2.74,2.74h0A2.74,2.74,0,0,1,229.47,68.49Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0.08,
    y: 153.62,
    width: 197.01,
    height: 52.66,
    rx: 10.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M124.31,193.48H52.24a2.75,2.75,0,0,1-2.75-2.74h0A2.74,2.74,0,0,1,52.24,188h72.07a2.73,2.73,0,0,1,2.74,2.74h0A2.74,2.74,0,0,1,124.31,193.48Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M228.12,193.48H146.56a2.75,2.75,0,0,1-2.75-2.74h0a2.74,2.74,0,0,1,2.75-2.74h81.56a2.74,2.74,0,0,1,2.75,2.74h0A2.75,2.75,0,0,1,228.12,193.48Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M78.31,207.64H52.24a2.75,2.75,0,0,1-2.75-2.74h0a2.74,2.74,0,0,1,2.75-2.74H78.31a2.73,2.73,0,0,1,2.74,2.74h0A2.74,2.74,0,0,1,78.31,207.64Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M153.53,207.64H93.24a2.74,2.74,0,0,1-2.74-2.74h0a2.74,2.74,0,0,1,2.74-2.74h60.29a2.74,2.74,0,0,1,2.74,2.74h0A2.74,2.74,0,0,1,153.53,207.64Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M227.66,207.64H164.55a2.75,2.75,0,0,1-2.75-2.74h0a2.74,2.74,0,0,1,2.75-2.74h63.11a2.74,2.74,0,0,1,2.74,2.74h0A2.74,2.74,0,0,1,227.66,207.64Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M101.35,221.8H52.24a2.75,2.75,0,0,1-2.75-2.74h0a2.74,2.74,0,0,1,2.75-2.74h49.11a2.74,2.74,0,0,1,2.74,2.74h0A2.74,2.74,0,0,1,101.35,221.8Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M226.84,221.8H137a2.74,2.74,0,0,1-2.74-2.74h0a2.74,2.74,0,0,1,2.74-2.74h89.83a2.74,2.74,0,0,1,2.75,2.74h0A2.75,2.75,0,0,1,226.84,221.8Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 472.77,
    y: 64.5,
    width: 170.29,
    height: 56.49,
    rx: 11.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M603.14,105.44H525.82a2.93,2.93,0,0,1-2.94-2.94h0a2.94,2.94,0,0,1,2.94-2.94h77.32a2.94,2.94,0,0,1,2.94,2.94h0A2.94,2.94,0,0,1,603.14,105.44Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M673.45,105.44H627a2.94,2.94,0,0,1-2.94-2.94h0A2.94,2.94,0,0,1,627,99.56h46.45a2.94,2.94,0,0,1,2.94,2.94h0A2.94,2.94,0,0,1,673.45,105.44Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M553.79,120.64h-28a2.94,2.94,0,0,1-2.94-3h0a2.94,2.94,0,0,1,2.94-2.94h28a2.94,2.94,0,0,1,2.94,2.94h0A3,3,0,0,1,553.79,120.64Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M634.48,120.64H569.8a3,3,0,0,1-2.94-3h0a2.94,2.94,0,0,1,2.94-2.94h64.68a2.94,2.94,0,0,1,2.94,2.94h0A3,3,0,0,1,634.48,120.64Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M673,120.64H646.3a2.94,2.94,0,0,1-2.94-3h0a2.94,2.94,0,0,1,2.94-2.94H673a2.94,2.94,0,0,1,2.94,2.94h0A3,3,0,0,1,673,120.64Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M578.5,135.83H525.82a2.94,2.94,0,0,1-2.94-2.94h0a2.94,2.94,0,0,1,2.94-2.95H578.5a3,3,0,0,1,3,2.95h0A3,3,0,0,1,578.5,135.83Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M672.07,135.83H616.76a2.94,2.94,0,0,1-2.94-2.94h0a2.94,2.94,0,0,1,2.94-2.95h55.31a2.94,2.94,0,0,1,2.94,2.95h0A2.94,2.94,0,0,1,672.07,135.83Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 33.25,
    y: 71.88,
    width: 197.01,
    height: 41.86,
    rx: 10.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M157.48,111.74H85.41A2.74,2.74,0,0,1,82.67,109h0a2.74,2.74,0,0,1,2.74-2.74h72.07a2.75,2.75,0,0,1,2.75,2.74h0A2.75,2.75,0,0,1,157.48,111.74Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M261.3,111.74H179.73A2.74,2.74,0,0,1,177,109h0a2.74,2.74,0,0,1,2.74-2.74H261.3A2.74,2.74,0,0,1,264,109h0A2.75,2.75,0,0,1,261.3,111.74Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M111.48,125.9H85.41a2.74,2.74,0,0,1-2.74-2.75h0a2.74,2.74,0,0,1,2.74-2.74h26.07a2.75,2.75,0,0,1,2.75,2.74h0A2.75,2.75,0,0,1,111.48,125.9Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M186.7,125.9H126.41a2.75,2.75,0,0,1-2.74-2.75h0a2.74,2.74,0,0,1,2.74-2.74H186.7a2.74,2.74,0,0,1,2.74,2.74h0A2.75,2.75,0,0,1,186.7,125.9Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 409.59,
    width: 31.83,
    height: 18.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "409.59 18.4 425.51 7.96 441.42 18.4 409.59 18.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M481.37,25,467.1,35.63a3.14,3.14,0,0,1-3.29,0L449.54,25Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M481.37,25,467.1,34.69a3.1,3.1,0,0,1-3.29,0L449.54,25Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 409.59,
    y: 23.16,
    width: 31.83,
    height: 18.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "409.59 41.56 425.51 31.11 441.42 41.56 409.59 41.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M481.37,48.11,467.1,58.78a3.1,3.1,0,0,1-3.29,0L449.54,48.11Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M481.37,48.11,467.1,57.85a3.1,3.1,0,0,1-3.29,0l-14.27-9.74Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 409.59,
    y: 46.32,
    width: 31.83,
    height: 18.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "409.59 64.72 425.51 54.27 441.42 64.72 409.59 64.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M481.37,71.26,467.1,81.94a3.1,3.1,0,0,1-3.29,0L449.54,71.26Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M481.37,71.26,467.1,81a3.1,3.1,0,0,1-3.29,0l-14.27-9.75Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M485.26,26.16v16h16v-16Zm15,15H486.24v-14h14.05Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M485.26,49.3v16h16v-16Zm15,15H486.24v-14h14.05Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M485.26,72.44v16h16v-16Zm15,15H486.24v-14h14.05Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "467.67 44.6 456 61.03 447.94 51.06 450.3 51.15 455.91 58.1 465.55 44.52 467.67 44.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "456.54 61.79 456 61.03 467.67 44.6 468.16 45.44 456.54 61.79"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 528.84,
    cy: 329.64,
    rx: 101.08,
    ry: 10.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 301.41,
    cy: 339.83,
    rx: 301.41,
    ry: 10.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 443,
    y: 86.64,
    width: 140,
    height: 238.99,
    rx: 7.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 431.47,
    y: 86.64,
    width: 140,
    height: 238.99,
    rx: 7.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 438.07,
    y: 166.03,
    width: 206.69,
    height: 130.09,
    rx: 2.19,
    transform: "translate(732.54 -335.28) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M617.21,171.81h0a2.64,2.64,0,0,1-2.63-2.64v-40.4a2.63,2.63,0,0,1,2.63-2.63h0a2.64,2.64,0,0,1,2.64,2.63v40.4A2.64,2.64,0,0,1,617.21,171.81Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M617.21,226.6h0a2.64,2.64,0,0,1-2.63-2.64V183.57a2.64,2.64,0,0,1,2.63-2.64h0a2.64,2.64,0,0,1,2.64,2.64V224A2.64,2.64,0,0,1,617.21,226.6Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M618.52,171.81h0a2.64,2.64,0,0,1-2.63-2.64v-40.4a2.63,2.63,0,0,1,2.63-2.63h0a2.64,2.64,0,0,1,2.64,2.63v40.4A2.64,2.64,0,0,1,618.52,171.81Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M618.52,226.6h0a2.64,2.64,0,0,1-2.63-2.64V183.57a2.64,2.64,0,0,1,2.63-2.64h0a2.64,2.64,0,0,1,2.64,2.64V224A2.64,2.64,0,0,1,618.52,226.6Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M513.61,212.89a6.37,6.37,0,1,1-6.36-6.36A6.36,6.36,0,0,1,513.61,212.89Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 479.32,
    y: 177.64,
    width: 64.16,
    height: 20.61,
    rx: 2.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M543.09,208.38H521.86a1.21,1.21,0,0,1-1.21-1.21h0a1.21,1.21,0,0,1,1.21-1.2h21.23a1.21,1.21,0,0,1,1.21,1.2h0A1.21,1.21,0,0,1,543.09,208.38Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M578.73,214.77H521.86a1.21,1.21,0,0,1-1.21-1.21h0a1.21,1.21,0,0,1,1.21-1.21h56.87a1.21,1.21,0,0,1,1.21,1.21h0A1.21,1.21,0,0,1,578.73,214.77Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M578.73,221.15H521.86a1.21,1.21,0,0,1-1.21-1.2h0a1.21,1.21,0,0,1,1.21-1.21h56.87a1.21,1.21,0,0,1,1.21,1.21h0A1.21,1.21,0,0,1,578.73,221.15Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M513.61,290.12a6.37,6.37,0,1,1-6.36-6.36A6.36,6.36,0,0,1,513.61,290.12Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 479.32,
    y: 254.87,
    width: 77.29,
    height: 20.61,
    rx: 2.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M543.09,285.61H521.86a1.21,1.21,0,0,1-1.21-1.2h0a1.21,1.21,0,0,1,1.21-1.21h21.23a1.21,1.21,0,0,1,1.21,1.21h0A1.21,1.21,0,0,1,543.09,285.61Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M591.87,292h-70a1.21,1.21,0,0,1-1.21-1.21h0a1.21,1.21,0,0,1,1.21-1.21h70a1.21,1.21,0,0,1,1.2,1.21h0A1.21,1.21,0,0,1,591.87,292Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M591.87,298.38h-70a1.21,1.21,0,0,1-1.21-1.2h0a1.21,1.21,0,0,1,1.21-1.21h70a1.21,1.21,0,0,1,1.2,1.21h0A1.2,1.2,0,0,1,591.87,298.38Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M499.6,249.91a6.36,6.36,0,1,1-6.36-6.37A6.36,6.36,0,0,1,499.6,249.91Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 465.31,
    y: 214.65,
    width: 74.79,
    height: 20.61,
    rx: 2.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M532.93,245.4H507.85a1.21,1.21,0,0,1-1.21-1.21h0a1.21,1.21,0,0,1,1.21-1.21h25.08a1.21,1.21,0,0,1,1.21,1.21h0A1.21,1.21,0,0,1,532.93,245.4Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M575.36,251.78H507.85a1.21,1.21,0,0,1-1.21-1.21h0a1.21,1.21,0,0,1,1.21-1.2h67.51a1.21,1.21,0,0,1,1.21,1.2h0A1.21,1.21,0,0,1,575.36,251.78Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M575.36,258.17H507.85a1.21,1.21,0,0,1-1.21-1.21h0a1.21,1.21,0,0,1,1.21-1.21h67.51a1.21,1.21,0,0,1,1.21,1.21h0A1.21,1.21,0,0,1,575.36,258.17Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 476.78,
    y: 115.38,
    width: 49.38,
    height: 42.11,
    rx: 2.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M549.08,155.37a9.64,9.64,0,1,1-9.64-9.64A9.65,9.65,0,0,1,549.08,155.37Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M555.28,182.44H523.59a15.87,15.87,0,0,1,31.69,0Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 110.43,
    y: 124.21,
    width: 335.27,
    height: 203.9,
    rx: 5.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 227.1,
    y: 94.51,
    width: 181.82,
    height: 317.93,
    rx: 3.87,
    transform: "translate(531.55 -89.48) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M517.41,343.21a5.21,5.21,0,0,1-.61,2.15l-5.35,9.91a5.15,5.15,0,0,1-4.53,2.71H129.11a5.15,5.15,0,0,1-4.54-2.71l-5.34-9.91a5.07,5.07,0,0,1-.61-2.15,5.14,5.14,0,0,1,5.14-5.45h388.5A5.15,5.15,0,0,1,517.41,343.21Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M517.41,343.21H118.62a5.14,5.14,0,0,1,5.14-5.45h388.5A5.15,5.15,0,0,1,517.41,343.21Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 236.11,
    y: 312.82,
    width: 83.9,
    height: 5.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 119.1,
    y: 143.14,
    width: 318.19,
    height: 16.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M432.07,176.2a4.95,4.95,0,1,1-4.94-4.94A4.95,4.95,0,0,1,432.07,176.2Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M448.43,176.2a4.95,4.95,0,1,1-4.94-4.94A4.95,4.95,0,0,1,448.43,176.2Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M464.79,176.2a4.95,4.95,0,1,1-4.94-4.94A4.95,4.95,0,0,1,464.79,176.2Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 322.69,
    y: 168.21,
    width: 105.07,
    height: 74.4,
    rx: 4.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M462.8,268H367.54a5.35,5.35,0,0,1-5.34-5.34V198.06a5.34,5.34,0,0,1,5.34-5.33H462.8a5.34,5.34,0,0,1,5.34,5.33v64.59A5.35,5.35,0,0,1,462.8,268Zm-95.26-74.4a4.48,4.48,0,0,0-4.48,4.47v64.59a4.49,4.49,0,0,0,4.48,4.48H462.8a4.48,4.48,0,0,0,4.47-4.48V198.06a4.47,4.47,0,0,0-4.47-4.47Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 380.47,
    y: 180.55,
    width: 69.41,
    height: 99.61,
    rx: 4.92,
    transform: "translate(605.58 -209.76) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M460.05,265.49H370.28a5.36,5.36,0,0,1-5.35-5.35V200.58a5.36,5.36,0,0,1,5.35-5.36h89.77a5.36,5.36,0,0,1,5.35,5.36v59.56A5.36,5.36,0,0,1,460.05,265.49Zm-89.77-69.41a4.5,4.5,0,0,0-4.49,4.5v59.56a4.5,4.5,0,0,0,4.49,4.49h89.77a4.5,4.5,0,0,0,4.49-4.49V200.58a4.5,4.5,0,0,0-4.49-4.5Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 322.69,
    y: 246.64,
    width: 16.03,
    height: 16.03,
    rx: 1.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 364.02,
    y: 272.98,
    width: 13.25,
    height: 13.25,
    rx: 0.26,
    transform: "translate(610.31 -115.99) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 322.69,
    y: 268.92,
    width: 16.03,
    height: 16.03,
    rx: 1.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 364.02,
    y: 295.25,
    width: 13.25,
    height: 13.25,
    rx: 0.26,
    transform: "translate(632.58 -93.72) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 344.4,
    y: 246.64,
    width: 65.39,
    height: 3.29,
    rx: 0.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 344.4,
    y: 253.44,
    width: 37.22,
    height: 3.29,
    rx: 0.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 390.64,
    y: 253.44,
    width: 18.97,
    height: 3.29,
    rx: 0.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 344.4,
    y: 271.32,
    width: 65.39,
    height: 3.29,
    rx: 0.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 344.4,
    y: 278.12,
    width: 37.22,
    height: 3.29,
    rx: 0.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 390.64,
    y: 278.12,
    width: 18.97,
    height: 3.29,
    rx: 0.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 130.33,
    y: 272.88,
    width: 15.63,
    height: 15.63,
    rx: 3.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M182.69,313.89H173.5a3.66,3.66,0,0,1-3.65-3.65v-9.19a3.66,3.66,0,0,1,3.65-3.65h9.19a3.66,3.66,0,0,1,3.65,3.65v9.19A3.66,3.66,0,0,1,182.69,313.89Zm-9.19-15.63a2.79,2.79,0,0,0-2.79,2.79v9.19A2.79,2.79,0,0,0,173.5,313h9.19a2.79,2.79,0,0,0,2.79-2.79v-9.19a2.79,2.79,0,0,0-2.79-2.79Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 155.28,
    y: 273.59,
    width: 21.47,
    height: 13.31,
    rx: 1.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M215.48,312.09h-19a1.47,1.47,0,0,1-1.47-1.47V299.76a1.47,1.47,0,0,1,1.47-1.47h19a1.47,1.47,0,0,1,1.47,1.47v10.86A1.47,1.47,0,0,1,215.48,312.09Zm-19-13.3a1,1,0,0,0-1,1v10.86a1,1,0,0,0,1,1h19a1,1,0,0,0,1-1V299.76a1,1,0,0,0-1-1Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M215.48,312.09h-19a.25.25,0,0,1-.24-.16.26.26,0,0,1,.09-.28l8.6-6.72a.25.25,0,0,1,.31.39l-8,6.28h17.58l-8-6.28a.26.26,0,0,1,0-.35.24.24,0,0,1,.35,0l8.61,6.72a.25.25,0,0,1,.08.28A.24.24,0,0,1,215.48,312.09Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M206,305.44a6,6,0,0,1-2.93-.76l-7.93-4.44A.24.24,0,0,1,195,300v-.27a1.47,1.47,0,0,1,1.47-1.47h19a1.47,1.47,0,0,1,1.47,1.47V300a.23.23,0,0,1-.13.21l-7.92,4.44A6,6,0,0,1,206,305.44Zm-10.49-5.56,7.8,4.36a5.45,5.45,0,0,0,5.38,0l7.8-4.36v-.12a1,1,0,0,0-1-1h-19a1,1,0,0,0-1,1Zm21.23.15Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M281.68,302.76H220.63a1.45,1.45,0,0,1-1.45-1.45h0a1.44,1.44,0,0,1,1.45-1.44h61.05a1.44,1.44,0,0,1,1.45,1.44h0A1.45,1.45,0,0,1,281.68,302.76Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M301.55,302.76h-11a1.45,1.45,0,0,1-1.45-1.45h0a1.44,1.44,0,0,1,1.45-1.44h11a1.43,1.43,0,0,1,1.44,1.44h0A1.44,1.44,0,0,1,301.55,302.76Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M238.13,309.93h-17.5a1.45,1.45,0,0,1-1.45-1.45h0a1.45,1.45,0,0,1,1.45-1.44h17.5a1.45,1.45,0,0,1,1.45,1.44h0A1.45,1.45,0,0,1,238.13,309.93Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M301.55,309.93H246.83a1.45,1.45,0,0,1-1.45-1.45h0a1.45,1.45,0,0,1,1.45-1.44h54.72a1.44,1.44,0,0,1,1.44,1.44h0A1.44,1.44,0,0,1,301.55,309.93Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 130.33,
    y: 246.71,
    width: 15.63,
    height: 15.63,
    rx: 3.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M182.69,287.72H173.5a3.66,3.66,0,0,1-3.65-3.65v-9.19a3.66,3.66,0,0,1,3.65-3.65h9.19a3.66,3.66,0,0,1,3.65,3.65v9.19A3.66,3.66,0,0,1,182.69,287.72Zm-9.19-15.63a2.79,2.79,0,0,0-2.79,2.79v9.19a2.79,2.79,0,0,0,2.79,2.79h9.19a2.79,2.79,0,0,0,2.79-2.79v-9.19a2.79,2.79,0,0,0-2.79-2.79Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 155.28,
    y: 247.43,
    width: 21.47,
    height: 13.3,
    rx: 1.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M215.48,285.93h-19a1.47,1.47,0,0,1-1.47-1.47V273.59a1.47,1.47,0,0,1,1.47-1.47h19a1.47,1.47,0,0,1,1.47,1.47v10.87A1.47,1.47,0,0,1,215.48,285.93Zm-19-13.31a1,1,0,0,0-1,1v10.87a1,1,0,0,0,1,1h19a1,1,0,0,0,1-1V273.59a1,1,0,0,0-1-1Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M215.48,285.93h-19a.25.25,0,0,1-.15-.45l8.6-6.72a.25.25,0,0,1,.31.39l-8,6.28h17.58l-8-6.28a.26.26,0,0,1,0-.35.24.24,0,0,1,.35,0l8.61,6.72a.25.25,0,0,1,.08.28A.25.25,0,0,1,215.48,285.93Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M206,279.27a6,6,0,0,1-2.93-.76l-7.93-4.44a.24.24,0,0,1-.12-.21v-.27a1.47,1.47,0,0,1,1.47-1.47h19a1.47,1.47,0,0,1,1.47,1.47v.27a.23.23,0,0,1-.13.21l-7.92,4.44A6,6,0,0,1,206,279.27Zm-10.49-5.56,7.8,4.36a5.45,5.45,0,0,0,5.38,0l7.8-4.36v-.12a1,1,0,0,0-1-1h-19a1,1,0,0,0-1,1Zm21.23.15Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "146.76 246.91 137.15 260.01 130.33 253.12 133.33 253.12 136.92 256.73 144.12 246.91 146.76 246.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M301.55,277.13H220.63a1.45,1.45,0,0,1-1.45-1.44h0a1.45,1.45,0,0,1,1.45-1.45h80.92a1.44,1.44,0,0,1,1.44,1.45h0A1.44,1.44,0,0,1,301.55,277.13Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M238.13,284.3h-17.5a1.44,1.44,0,0,1-1.45-1.44h0a1.44,1.44,0,0,1,1.45-1.44h17.5a1.44,1.44,0,0,1,1.45,1.44h0A1.44,1.44,0,0,1,238.13,284.3Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M301.55,284.3H246.83a1.44,1.44,0,0,1-1.45-1.44h0a1.44,1.44,0,0,1,1.45-1.44h54.72a1.43,1.43,0,0,1,1.44,1.44h0A1.43,1.43,0,0,1,301.55,284.3Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 130.33,
    y: 220.55,
    width: 15.63,
    height: 15.63,
    rx: 3.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M182.69,261.55H173.5a3.66,3.66,0,0,1-3.65-3.65v-9.19a3.66,3.66,0,0,1,3.65-3.65h9.19a3.66,3.66,0,0,1,3.65,3.65v9.19A3.66,3.66,0,0,1,182.69,261.55Zm-9.19-15.63a2.79,2.79,0,0,0-2.79,2.79v9.19a2.79,2.79,0,0,0,2.79,2.79h9.19a2.79,2.79,0,0,0,2.79-2.79v-9.19a2.79,2.79,0,0,0-2.79-2.79Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 155.28,
    y: 221.26,
    width: 21.47,
    height: 13.3,
    rx: 1.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M215.48,259.76h-19a1.47,1.47,0,0,1-1.47-1.47V247.43a1.47,1.47,0,0,1,1.47-1.47h19a1.47,1.47,0,0,1,1.47,1.47v10.86A1.47,1.47,0,0,1,215.48,259.76Zm-19-13.31a1,1,0,0,0-1,1v10.86a1,1,0,0,0,1,1h19a1,1,0,0,0,1-1V247.43a1,1,0,0,0-1-1Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M215.48,259.76h-19a.25.25,0,0,1-.15-.45l8.6-6.72a.25.25,0,0,1,.31.39l-8,6.28h17.58l-8-6.28a.26.26,0,0,1,0-.35.24.24,0,0,1,.35,0l8.61,6.72a.25.25,0,0,1,.08.28A.25.25,0,0,1,215.48,259.76Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M206,253.1a6,6,0,0,1-2.93-.76l-7.93-4.44a.24.24,0,0,1-.12-.21v-.26a1.47,1.47,0,0,1,1.47-1.47h19a1.47,1.47,0,0,1,1.47,1.47v.26a.23.23,0,0,1-.13.21l-7.92,4.44A6,6,0,0,1,206,253.1Zm-10.49-5.56,7.8,4.37a5.52,5.52,0,0,0,5.38,0l7.8-4.37v-.11a1,1,0,0,0-1-1h-19a1,1,0,0,0-1,1Zm21.23.15Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "146.76 220.8 137.15 233.9 130.33 227.01 133.33 227.01 136.92 230.62 144.12 220.8 146.76 220.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M276.28,251.51H220.63a1.45,1.45,0,0,1-1.45-1.45h0a1.44,1.44,0,0,1,1.45-1.44h55.65a1.44,1.44,0,0,1,1.44,1.44h0A1.45,1.45,0,0,1,276.28,251.51Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M301.29,251.51H286.54a1.45,1.45,0,0,1-1.44-1.45h0a1.44,1.44,0,0,1,1.44-1.44h14.75a1.44,1.44,0,0,1,1.45,1.44h0A1.45,1.45,0,0,1,301.29,251.51Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M250.1,258.68H220.63a1.45,1.45,0,0,1-1.45-1.44h0a1.45,1.45,0,0,1,1.45-1.45H250.1a1.45,1.45,0,0,1,1.45,1.45h0A1.45,1.45,0,0,1,250.1,258.68Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M301.55,258.68H258.8a1.45,1.45,0,0,1-1.45-1.44h0a1.45,1.45,0,0,1,1.45-1.45h42.75a1.44,1.44,0,0,1,1.44,1.45h0A1.44,1.44,0,0,1,301.55,258.68Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 130.33,
    y: 194.38,
    width: 15.63,
    height: 15.63,
    rx: 3.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M182.69,235.38H173.5a3.66,3.66,0,0,1-3.65-3.65v-9.19a3.66,3.66,0,0,1,3.65-3.65h9.19a3.66,3.66,0,0,1,3.65,3.65v9.19A3.66,3.66,0,0,1,182.69,235.38Zm-9.19-15.63a2.8,2.8,0,0,0-2.79,2.79v9.19a2.79,2.79,0,0,0,2.79,2.79h9.19a2.79,2.79,0,0,0,2.79-2.79v-9.19a2.8,2.8,0,0,0-2.79-2.79Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 155.28,
    y: 195.09,
    width: 21.47,
    height: 13.31,
    rx: 1.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M215.48,233.59h-19a1.47,1.47,0,0,1-1.47-1.47V221.26a1.47,1.47,0,0,1,1.47-1.47h19a1.47,1.47,0,0,1,1.47,1.47v10.86A1.47,1.47,0,0,1,215.48,233.59Zm-19-13.31a1,1,0,0,0-1,1v10.86a1,1,0,0,0,1,1h19a1,1,0,0,0,1-1V221.26a1,1,0,0,0-1-1Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M215.48,233.59h-19a.25.25,0,0,1-.15-.45l8.6-6.72a.25.25,0,0,1,.35,0,.24.24,0,0,1,0,.35l-8,6.28h17.58l-8-6.28a.26.26,0,0,1,0-.35.25.25,0,0,1,.35,0l8.61,6.72a.25.25,0,0,1,.08.28A.25.25,0,0,1,215.48,233.59Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M206,226.94a6,6,0,0,1-2.93-.77l-7.93-4.43a.27.27,0,0,1-.12-.22v-.26a1.47,1.47,0,0,1,1.47-1.47h19a1.47,1.47,0,0,1,1.47,1.47v.26a.26.26,0,0,1-.13.22l-7.92,4.43A6.06,6.06,0,0,1,206,226.94Zm-10.49-5.57,7.8,4.37a5.52,5.52,0,0,0,5.38,0l7.8-4.37v-.11a1,1,0,0,0-1-1h-19a1,1,0,0,0-1,1Zm21.23.15Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M301.55,225.88H220.63a1.44,1.44,0,0,1-1.45-1.44h0a1.45,1.45,0,0,1,1.45-1.45h80.92a1.44,1.44,0,0,1,1.44,1.45h0A1.43,1.43,0,0,1,301.55,225.88Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M238.13,233.06h-17.5a1.45,1.45,0,0,1-1.45-1.45h0a1.44,1.44,0,0,1,1.45-1.44h17.5a1.44,1.44,0,0,1,1.45,1.44h0A1.45,1.45,0,0,1,238.13,233.06Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M301.55,233.06H246.83a1.45,1.45,0,0,1-1.45-1.45h0a1.44,1.44,0,0,1,1.45-1.44h54.72a1.43,1.43,0,0,1,1.44,1.44h0A1.44,1.44,0,0,1,301.55,233.06Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 130.33,
    y: 168.21,
    width: 15.63,
    height: 15.63,
    rx: 3.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M182.69,209.21H173.5a3.65,3.65,0,0,1-3.65-3.65v-9.18a3.65,3.65,0,0,1,3.65-3.65h9.19a3.65,3.65,0,0,1,3.65,3.65v9.18A3.65,3.65,0,0,1,182.69,209.21Zm-9.19-15.62a2.79,2.79,0,0,0-2.79,2.79v9.18a2.79,2.79,0,0,0,2.79,2.79h9.19a2.79,2.79,0,0,0,2.79-2.79v-9.18a2.79,2.79,0,0,0-2.79-2.79Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 155.28,
    y: 168.92,
    width: 21.47,
    height: 13.3,
    rx: 1.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M215.48,207.42h-19A1.47,1.47,0,0,1,195,206V195.09a1.47,1.47,0,0,1,1.47-1.47h19a1.47,1.47,0,0,1,1.47,1.47V206A1.47,1.47,0,0,1,215.48,207.42Zm-19-13.31a1,1,0,0,0-1,1V206a1,1,0,0,0,1,1h19a1,1,0,0,0,1-1V195.09a1,1,0,0,0-1-1Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M215.48,207.42h-19a.26.26,0,0,1-.24-.17.24.24,0,0,1,.09-.27l8.6-6.73a.26.26,0,0,1,.35,0,.24.24,0,0,1,0,.35l-8,6.28h17.58l-8-6.28a.25.25,0,1,1,.31-.39l8.61,6.73a.23.23,0,0,1,.08.27A.25.25,0,0,1,215.48,207.42Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M206,200.77A6,6,0,0,1,203,200l-7.93-4.43a.27.27,0,0,1-.12-.22v-.26a1.47,1.47,0,0,1,1.47-1.47h19a1.47,1.47,0,0,1,1.47,1.47v.26a.26.26,0,0,1-.13.22L208.9,200A6.06,6.06,0,0,1,206,200.77Zm-10.49-5.57,7.8,4.37a5.52,5.52,0,0,0,5.38,0l7.8-4.37v-.11a1,1,0,0,0-1-1h-19a1,1,0,0,0-1,1Zm21.23.15Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "146.76 168.21 137.15 181.31 130.33 174.42 133.33 174.42 136.92 178.03 144.12 168.21 146.76 168.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M272.84,200.26H220.63a1.45,1.45,0,0,1-1.45-1.45h0a1.45,1.45,0,0,1,1.45-1.44h52.21a1.45,1.45,0,0,1,1.45,1.44h0A1.45,1.45,0,0,1,272.84,200.26Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M300.64,200.26H277.29a1.45,1.45,0,0,1-1.45-1.45h0a1.45,1.45,0,0,1,1.45-1.44h23.35a1.44,1.44,0,0,1,1.44,1.44h0A1.44,1.44,0,0,1,300.64,200.26Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M258.76,207.43H220.63a1.45,1.45,0,0,1-1.45-1.44h0a1.45,1.45,0,0,1,1.45-1.45h38.13a1.45,1.45,0,0,1,1.45,1.45h0A1.45,1.45,0,0,1,258.76,207.43Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M286.54,207.43H267.46A1.45,1.45,0,0,1,266,206h0a1.45,1.45,0,0,1,1.45-1.45h19.08A1.45,1.45,0,0,1,288,206h0A1.45,1.45,0,0,1,286.54,207.43Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M301.29,207.43H295a1.45,1.45,0,0,1-1.45-1.44h0a1.45,1.45,0,0,1,1.45-1.45h6.33a1.45,1.45,0,0,1,1.45,1.45h0A1.45,1.45,0,0,1,301.29,207.43Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M211.44,133.46A86.51,86.51,0,0,1,225,137c5.29,2.11,4,9.33,4,9.33l-10.18.43s-24.75-10.64-24.86-11,1-5.62,1-5.62Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M219.82,107.71s.75,20.57-1.33,27.34h-4.1l-1-24.06A11,11,0,0,1,219.82,107.71Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M219.75,108.78a26.58,26.58,0,0,1-2.16,6h0l-.35.72,0,.06c-.57,1.17-1.21,2.46-1.94,4-.57,1.18-3.19,6.14-3.83,10.53a10,10,0,0,0,0,3.37c-7,2.18-14.28,5.53-20.29,3.58h0c-2.48-.8-4.8,1.32-6.35.12-1-4.43,1.62-4.83,2.53-6.35,3.08-5.11,3.83-9.36,4.84-17.72.29-2.39.05-3.78.65-5a5.63,5.63,0,0,1,2.24-2.14c2.89-1.79,7.36-4.5,13.6-4.5,3.48,0,6.85,2,9.06,3.4C219.1,105.79,220.11,107.15,219.75,108.78Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M217.74,149.4l-27.43-.24c-3,0-4-2.19-5-4.45-1.43-3.28-1.29-5.94-.56-7.75a4,4,0,0,1,2.5-2.59c3.52-.71,9.28-.38,14.83.25h0c7.89.9,15.36,2.42,15.36,2.42Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M212.2,179.55c-.19,1-.39,2-.58,3.14l-4.18.84-.36-1.32c0-.84.07-1.64.1-2.43A8.38,8.38,0,0,0,212.2,179.55Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M216.14,191.68l-5.11.21a2.61,2.61,0,0,1-.69-.1,2.49,2.49,0,0,1-1.28-.91l-3.4-4.76a1.29,1.29,0,0,1-.16-.41,4.63,4.63,0,0,1-.09-.62,4.17,4.17,0,0,1,0-.5c.05-.88,1.09-1.64,1.64-2.35l0,0c2.29.31,2.38-.69,3.32-.7h0a1.72,1.72,0,0,1,1.68,1.45,22.52,22.52,0,0,0,2.19,5.72A18.43,18.43,0,0,0,216.14,191.68Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M211.29,191.89H211a2.61,2.61,0,0,1-.69-.1,2.49,2.49,0,0,1-1.28-.91l-3.4-4.76a1.29,1.29,0,0,1-.16-.41,4.63,4.63,0,0,1-.09-.62,4.17,4.17,0,0,1,0-.5C206.14,185.81,208.89,190.24,211.29,191.89Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M211.36,191.89a.61.61,0,0,1-.6-.71h0c.26-1.55,2-2.22,3.47-2.22s2.19.68,2.29,2.59h0a.34.34,0,0,1-.34.34Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M235.32,182.21l-.35,1.32-4.19-.84c-.25-1.43-.5-2.79-.75-4.07a14.31,14.31,0,0,0,5.17.16C235.22,179.89,235.26,181,235.32,182.21Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M236,184.76l-2.59,6a2,2,0,0,1-1.26,1.1,2.25,2.25,0,0,1-.52.07h-2.37a1.41,1.41,0,0,1-1.3-2c.16-.35.33-.74.54-1.16a23.34,23.34,0,0,0,2-5.82,1.6,1.6,0,0,1,1.58-1.44c1.28,0,1.81,1.53,3.23.7l0,0a3.52,3.52,0,0,1,.61,1.91C236,184.36,236,184.56,236,184.76Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M236,184.76l-2.59,6a2,2,0,0,1-1.26,1.1l3.81-7.66C236,184.36,236,184.56,236,184.76Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M232.4,191.89a.6.6,0,0,0,.59-.71h0c-.25-1.55-2-2.22-3.47-2.22s-2.18.68-2.28,2.59h0a.34.34,0,0,0,.34.34Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M202.85,135.05h12.62l2.67,2H202.67a.9.9,0,0,1-.9-.91h0A1.08,1.08,0,0,1,202.85,135.05Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M250.93,113.87H225.69a1.22,1.22,0,0,0-1.11.72l-9.24,20.74a1.21,1.21,0,0,0,1.11,1.71h25.24a1.22,1.22,0,0,0,1.11-.72L252,115.58A1.22,1.22,0,0,0,250.93,113.87Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M253,113.87H227.48a1.11,1.11,0,0,0-1,.65l-9.35,21a1.1,1.1,0,0,0,1,1.55h25.48a1.1,1.1,0,0,0,1-.65l9.35-21A1.1,1.1,0,0,0,253,113.87Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M239.61,125.46c0,1.73-1.82,3.13-4.06,3.13s-4.05-1.4-4.05-3.13,1.82-3.13,4.05-3.13S239.61,123.73,239.61,125.46Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M210,130.89l-.22.22L204.66,136h0a44.93,44.93,0,0,1-3.81-5.63,94.87,94.87,0,0,1-7.72-17.54c-.25-.82-.87-3.12-.16-4.72a2.6,2.6,0,0,1,1.54-1.43c4-1.46,5.31,1.31,5.9,3.1a101.82,101.82,0,0,0,7.3,17.46c.28.51.54,1,.77,1.35a26.09,26.09,0,0,0,1.49,2.28Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M222.44,119.7l6.87-1.93a.42.42,0,0,1,.51.31h0a.42.42,0,0,1-.25.46l-3.84,1.53,4.52-1.06a.4.4,0,0,1,.48.32h0a.39.39,0,0,1-.26.44l-4.08,1.48,4-.48a.38.38,0,0,1,.42.38h0a.38.38,0,0,1-.28.36l-4.22,1.15,3.45-.36a.36.36,0,0,1,.41.39h0a.38.38,0,0,1-.29.33l-5.6,1.26-1-1.43Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M224.29,119.55a4.85,4.85,0,0,0-1.57.06,4.46,4.46,0,0,0-2.37,1.56c-11.72,9.63-14.13,7.67-16.12,11.33-.72,1.31.43,3.54.43,3.54h0a8.17,8.17,0,0,0,6-1.67A67.77,67.77,0,0,0,221.32,125l1.71-.28a3.58,3.58,0,0,0,2.95-3A1.93,1.93,0,0,0,224.29,119.55Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 167.9,
    cy: 79.95,
    rx: 5.51,
    ry: 4.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M221,126.4a5.43,5.43,0,0,1,0,.57,53.65,53.65,0,0,1-9,7.32,10.34,10.34,0,0,1-7.24,1.75h0a4.37,4.37,0,0,1-.21-4.6,3.64,3.64,0,0,1,1.34-1.42c.25-.16.53-.32.85-.49.52-.27,1.13-.55,1.84-.9,1-.5,2.29-1.12,3.82-2a64.43,64.43,0,0,0,7.31-5.08A13.46,13.46,0,0,1,221,126.4Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M205.4,92s-2.36-1.14-4.26-.39-4.49,6.09.68,10C203.32,99.71,205.4,92,205.4,92Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M209.92,84.66c4.9-.59,11.12,4.13,6.74,11.67-4.28,2.89-5.74-4.3-5.74-4.3l-4.2-2.45S207.15,85,209.92,84.66Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M215.15,101.06c0,.14-.05.27-.08.41h0a6.09,6.09,0,0,1-1.58,2.84,24.59,24.59,0,0,1-3.77,3.25,3.42,3.42,0,0,1-2.18.53h0a3.42,3.42,0,0,1-2-.92,25.5,25.5,0,0,1-3.1-3.88,6.13,6.13,0,0,1-1-2.77,6.34,6.34,0,0,1,0-.76c0-1.21,0-2.83.1-4.09a14.42,14.42,0,0,1,.16-1.89c.77-2.75,1.81-4.68,4.23-5.26,1.7.15,9.59-2.28,10.23,6.49a.33.33,0,0,1,0,.1C216.08,95.66,215.53,99,215.15,101.06Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M208.9,101.8a4.82,4.82,0,0,1-.25-3.67,8.61,8.61,0,0,0,.25,3.67Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M208.56,90.41s-3.18-.94-4.17-.5c-1.32.59-2.4,2.11-2.78,6.12l-.33,2.81c-1.38-1.57-3.67-5.69-3-8.13.82-3,4.25-6.49,7.16-6.51,2.73,0,3.46.61,3.35,3.51C208.76,88.46,208.68,89.35,208.56,90.41Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M209.43,102.87c0,.3-.5.5-1.05.45s-1-.34-.95-.64.46-.14,1-.09S209.46,102.56,209.43,102.87Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M217.62,99.62c-.67,1.08-1.42,1.9-2.55,1.85a13.69,13.69,0,0,0-.24-6.45,6.46,6.46,0,0,0-6.27-4.61h0c.12-1.06.2-2,.23-2.7h0a6.37,6.37,0,0,1,6.31,1.71,31.64,31.64,0,0,1,2.07,2.43A6.9,6.9,0,0,1,217.62,99.62Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M206.23,97.39c-.06.57-.31,1-.58,1s-.44-.5-.39-1.07.31-1,.58-1S206.28,96.82,206.23,97.39Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M211.84,97.91c-.05.57-.31,1-.58,1s-.44-.5-.39-1.07.31-1,.58-1S211.89,97.34,211.84,97.91Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M203.51,96a5.61,5.61,0,0,1,3-1.47,8.47,8.47,0,0,1,1.13-.1.37.37,0,1,1,0,.74,5.67,5.67,0,0,0-3,.5,4.54,4.54,0,0,0-.89.55.15.15,0,0,1-.19-.22Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M213.79,97a5.53,5.53,0,0,0-2.67-2,8,8,0,0,0-1.09-.31.37.37,0,1,0-.11.74,5.87,5.87,0,0,1,2.88,1,5.12,5.12,0,0,1,.76.71.15.15,0,0,0,.23-.18Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M208.75,105.37a2.94,2.94,0,0,1-.46,0,.1.1,0,0,1-.09-.12.11.11,0,0,1,.12-.09,2.59,2.59,0,0,0,1.94-.56.1.1,0,0,1,.15,0,.11.11,0,0,1,0,.15A2.59,2.59,0,0,1,208.75,105.37Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M208.72,88.88a2.72,2.72,0,0,0-.75,2.59,3.16,3.16,0,0,0,2,1.72c3.17,1.09,1.95,2.68,3.79,3.8,2.68,1.64,6,1.12,6.24-.93-5,.66-4.27-2-5.09-4.92A3.91,3.91,0,0,0,208.72,88.88Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M205.1,100a2.73,2.73,0,1,1,3-2.47A2.73,2.73,0,0,1,205.1,100Zm.47-5.12a2.41,2.41,0,1,0,2.18,2.62A2.41,2.41,0,0,0,205.57,94.91Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M211.51,100.62a2.73,2.73,0,1,1,3-2.47A2.73,2.73,0,0,1,211.51,100.62ZM212,95.5a2.42,2.42,0,1,0,2.18,2.62A2.43,2.43,0,0,0,212,95.5Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M209.21,97.63a.15.15,0,0,1-.12-.07.72.72,0,0,0-.51-.23.73.73,0,0,0-.55.14.16.16,0,0,1-.22-.23,1.07,1.07,0,0,1,.8-.23,1,1,0,0,1,.74.37.15.15,0,0,1,0,.22A.13.13,0,0,1,209.21,97.63Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M201.52,97.17a.16.16,0,0,1-.13-.09.15.15,0,0,1,.08-.21l1.42-.65a.15.15,0,0,1,.21.08.16.16,0,0,1-.08.21l-1.42.65Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M215.34,98.39l-.08,0-1.06-.82a.15.15,0,0,1,0-.22.16.16,0,0,1,.22,0l1.07.82a.16.16,0,0,1,0,.22A.15.15,0,0,1,215.34,98.39Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M201.4,100.52s-.48,0-.28-1.07-.32-2.37-.28-3.06.7-.74.81-.75A48.44,48.44,0,0,0,201.4,100.52Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M221.37,146.37c-.5,6.24-2.39,7.4-5.14,16.21h0c-.06.27-2.89,12.74-3.88,16.89l-.15.07a8.38,8.38,0,0,1-5,.23,5.63,5.63,0,0,1-.93-.3c0-.93.11-3.57.26-7.07.36-8,1.08-20.46,2.25-27.61s8.69-7.76,8.69-7.76h0C217.54,137.14,221.75,141.58,221.37,146.37Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M235.88,172.39c0,2.63,0,4.87,0,6.17a2.69,2.69,0,0,1-.66.22,14.31,14.31,0,0,1-5.17-.16l-.27-.06c-3.76-18.1-8-27.1-8.39-32.19-.38-4.79,3.49-9.23,3.58-9.33h0s7.09,1.81,8.93,8.71a47.86,47.86,0,0,1,1.52,9C235.83,158.27,235.89,166.35,235.88,172.39Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M202.08,134.62c-5.55-.63-11.31-1-14.83-.25a4,4,0,0,0-2.5,2.59c-.9-4.24,1.67-4.66,2.57-6.15,3.08-5.11,3.83-9.36,4.84-17.72.29-2.39.05-3.78.65-5l.14,0c-.71,1.6-.09,3.9.16,4.72a94.87,94.87,0,0,0,7.72,17.54l-7.8-11.5s-2.25,9.6-5.25,13.94A74.36,74.36,0,0,1,202.08,134.62Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M217.17,115.64c-.56,1.15-1.19,2.42-1.9,3.92a51.47,51.47,0,0,0-3,7c-1.53.9-2.78,1.52-3.82,2-.23-.39-.49-.84-.77-1.35.27-.16.55-.33.83-.52a1.9,1.9,0,0,0-.28-3.3,18.88,18.88,0,0,1-1.79-1,.13.13,0,0,1,.11-.24,7.12,7.12,0,0,0,8.16-2.45A31.73,31.73,0,0,0,217.17,115.64Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M221,126.4a5.43,5.43,0,0,1,0,.57,53.65,53.65,0,0,1-9,7.32,10.34,10.34,0,0,1-7.24,1.75h0a44.93,44.93,0,0,1-3.81-5.63,94.87,94.87,0,0,1-7.72-17.54c-.25-.82-.87-3.12-.16-4.72a2.6,2.6,0,0,1,1.54-1.43s-.6,8,7.16,19.38a12.07,12.07,0,0,0,4.12,3.92,9,9,0,0,0,4,1.11C214.81,131.34,219.59,127.58,221,126.4Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M221.37,146.37c-.5,6.24-2.39,7.4-5.14,16.21h0c-.06.27-2.89,12.74-3.88,16.89l-.15.07a8.38,8.38,0,0,1-5,.23,5.63,5.63,0,0,1-.93-.3c0-.93.11-3.57.26-7.07,3.13.17,5.13-2.4,9.93-14.41,5.67-14.21,1.06-20.86,1-21C217.54,137.14,221.75,141.58,221.37,146.37Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M235.88,172.39c0,2.63,0,4.87,0,6.17a2.69,2.69,0,0,1-.66.22,14.31,14.31,0,0,1-5.17-.16l-.27-.06c-3.76-18.1-8-27.1-8.39-32.19-.38-4.79,3.49-9.23,3.58-9.33-.09.13-4.43,6.46,1.05,21C229.46,167.15,233.4,170.88,235.88,172.39Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M192.63,123.35l.12,17.12a1.23,1.23,0,0,1-1.22,1.24l-29,.19a1.23,1.23,0,0,1-1.24-1.22l-.11-17.13a1.22,1.22,0,0,1,1.22-1.23h.65l13.92,10,13.78-10.14h.65A1.21,1.21,0,0,1,192.63,123.35Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "150.12 97.19 136.33 107.32 122.42 97.37 150.12 97.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M192,123.35l.11,17.13a1.21,1.21,0,0,1-1.22,1.23l-29,.2a1.23,1.23,0,0,1-1.23-1.22l-.12-17.13a1.24,1.24,0,0,1,1.22-1.24h.65l13.92,10,13.78-10.14h.65A1.24,1.24,0,0,1,192,123.35Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M191.38,141.71,179,130.79a3.35,3.35,0,0,0-4.46,0l-12.2,11.08Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M190.84,141.71,178.5,130.8a3.34,3.34,0,0,0-4.46,0l-12.2,11.08Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M191.25,122.13l-12.2,11.08a3.33,3.33,0,0,1-4.45,0l-12.35-10.92Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M190.71,122.13l-12.2,11.08a3.32,3.32,0,0,1-4.45,0l-12.35-10.92Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M184.7,117.94a1.28,1.28,0,1,1-1.27-1.27A1.27,1.27,0,0,1,184.7,117.94Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M188.72,117.94a1.27,1.27,0,1,1-1.27-1.27A1.27,1.27,0,0,1,188.72,117.94Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M192.75,117.94a1.28,1.28,0,1,1-1.28-1.27A1.28,1.28,0,0,1,192.75,117.94Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M145.12,331.45c-.37.71-1.47,2.85-2.24,3.2a2.3,2.3,0,0,0-1.28,2.72l0,.05a.46.46,0,0,0,.45.34h4.31A5.57,5.57,0,0,0,150,335l3.24-8.38A2.64,2.64,0,0,0,153,324c-.83-1.14-1.52-2.54-2.63-2-.82.4.22,1.84-1.67,3.09-1.17.77-2.38-.86-3.1.49C145.13,326.41,146.54,328.73,145.12,331.45Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M120.69,330.46c-.91,0-1.63,2.62-8.32,4.35a2.11,2.11,0,0,0-1.43,2.85c.08.18.14.29.14.29h15.23a.9.9,0,0,0,.79-.5l.21-.45a7.11,7.11,0,0,0,.53-4.56c-.17-.77-.46-1.43-.93-1.55-1.27-.31-2,.92-3.56.92S121.67,330.46,120.69,330.46Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M156.4,220.7a5.07,5.07,0,0,0-2.33-.34c-1.55.06-.94,1.78-.94,1.78l2.55,1.05Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M148.2,263.33l-.6,1.34-1.67,3.71-10.38,23.06H122.82s2.41-16.87,5-25.59c.28-.94.56-1.79.85-2.52Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M149.25,325.18a14.71,14.71,0,0,1-4.89,1.48c-2.12-3.7-4.66-7.56-7.17-11.14-1.13-1.61-2.25-3.16-3.33-4.62-4.39-5.95-8-10.28-8-10.28a15.42,15.42,0,0,1-3-9.18h12.73a45.64,45.64,0,0,1,4.23,4.85,20,20,0,0,1,2,3.1c1.79,3.64,9.64,21.6,9.9,22.19h0S152.24,323.44,149.25,325.18Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M156.36,263.33l-.06.34a33,33,0,0,1-.79,3.25c-3.41,11.63-14.18,31.15-14.18,31.15l-11.09-1.54s.31-1.65,1.06-5.09c1-4.52,2.76-12.14,5.62-23.14.07-.26.14-.52.2-.78.27-1,.54-2,.82-3.09.09-.36.19-.73.29-1.1Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M141.33,298.07s0,.18,0,.48h0a35.91,35.91,0,0,1-1.11,6.91c-.66,2.09-2,5.48-3.62,9.16-3.56,8.25-8.19,18-8.19,18a11.16,11.16,0,0,1-5.31.42c-2.76-.52-3.47-2.25-3.47-2.25l.12-.3c1-2.58,8.14-21.11,10.53-33.94l8.34,1.16,2.4.33Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M143.28,224.27c-10.63,6.47-19.43,22.35-19.43,22.35l6.32,2.71a103.24,103.24,0,0,0,11.86-15Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M157.9,252s-.27.46-1.65.46-1.7-2.33-1.7-2.33l3.35-1.58.6,1.7Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M113.35,233.63l-1.69,3.44s11.37,11.17,13.72,12a10,10,0,0,0,4.79.28,7.7,7.7,0,0,0-1-5C127.69,241.57,125.26,242.73,113.35,233.63Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M161.83,237.73c-1.06,5.62-3.2,6.44-4.31,11.09a24,24,0,0,0-.54,3.47,48.21,48.21,0,0,0-.18,6.89c0,1.14,1.12,1.11-.39,3.05,0,0-5.2,3.24-18.69,1.88-7.34-.75-9-1.78-9.1-1.87h0a2.59,2.59,0,0,1,.91-2.67c3.15-5.9,5.25-6.73,6.3-25.22,0-.17,0-.33,0-.49a11.77,11.77,0,0,1,11.4-10.38,16.34,16.34,0,0,0,8.66-.24,31.16,31.16,0,0,1,6.25,1.92A53,53,0,0,1,161.83,237.73Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M156.8,259.18c0,1.14,1.12,1.11-.39,3.05,0,0-5.2,3.24-18.69,1.88-7.34-.75-9-1.78-9.1-1.87h0c14.46,3.42,25.89.54,26.19-1a17.81,17.81,0,0,0,.21-2.58,3.63,3.63,0,0,0-2.64-3.62,23.28,23.28,0,0,1-4.17-1.71c-4.14-2.14-12.78-11.2-12.78-11.2l.31-2.72,1.76.33,1.35.82s5.7,3.55,5.92,3.77,8.33,4.41,8.66,4.46,2.6,0,4.1,0a24,24,0,0,0-.54,3.47A48.21,48.21,0,0,0,156.8,259.18Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M157.81,250.33c-.75,1.86-1.23,3-1.23,3L150.33,250s.54-2.12,1.28-5C156.14,246.22,157.45,248.68,157.81,250.33Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M164.34,233.39c-.89,2.92-2.19,7.8-3.3,10.92a2.73,2.73,0,0,1-1.34,3.34,4.45,4.45,0,0,1-.95,1.42,4,4,0,0,0-.94,1.26c-.36-1.65-1.67-4.11-6.2-5.29a2.88,2.88,0,0,0,0-1.17.25.25,0,0,0,0-.08h0a2.91,2.91,0,0,1,.84-2.59c.82-3.08,2-6.72,2.64-8.76.83-2.67,1.58-4.75,3.32-6.43a4,4,0,0,1,4.2-.66,3.68,3.68,0,0,1,2.4,3.47A15.17,15.17,0,0,1,164.34,233.39Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M107.93,232.23l-1.09-1a.64.64,0,0,1-.07-.83h0a.23.23,0,0,1,.29-.06,21.2,21.2,0,0,0,2.19,1.16c.88.4,1.88.67,2.12.85.55.41-1.16.68-1.16.68a.23.23,0,0,1-.3.11l-1.91-.83Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M104.91,232.68l-1.67-1.4a.25.25,0,0,1,0-.4h0a.86.86,0,0,1,1,0l1.53,1,2.39.46-2,.58Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M103.8,232.45l-1.67-1.39a.26.26,0,0,1,0-.41h0a.89.89,0,0,1,1,0l1.52,1,2.44.72-2,.31Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M106.44,232.16h0l-1.79-.53h0l-1.52-1a.86.86,0,0,0-1,0,.22.22,0,0,0-.07.09s0,0,0,0,0,0,0,0a.27.27,0,0,1,.09-.12.92.92,0,0,1,1,0l1.52,1,1.78.53a0,0,0,0,1,0,0S106.45,232.16,106.44,232.16Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M102.94,232.68l-1.67-1.4a.25.25,0,0,1,0-.4h0a.86.86,0,0,1,1,0l1.53,1,2.44.58-2,.46Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M105.08,232.16h0l-1.29-.3h0l-1.53-1a.81.81,0,0,0-.94,0,.22.22,0,0,0-.09.17.21.21,0,0,0,.08.17,0,0,0,0,1,0,.06h-.05a.27.27,0,0,1-.1-.24.25.25,0,0,1,.12-.22.89.89,0,0,1,1,0l1.52,1,1.29.3a.05.05,0,0,1,0,0Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M113.35,233.63a4.09,4.09,0,0,0-2.51-1.44,15.18,15.18,0,0,0-2.11.06l-4.64.2-2.38-1a.64.64,0,0,0-.85.33h0a.29.29,0,0,0,.12.38l2.6,1.46,1.42.21a10.08,10.08,0,0,1,4.16,1.6l2.5,1.68Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M104.09,232.49h0l-2.38-1a.62.62,0,0,0-.5,0,0,0,0,0,1,0,0s0,0,0-.05a.68.68,0,0,1,.56,0l2.37,1,4.64-.19s0,0,0,0a0,0,0,0,1,0,0l-4.64.2Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M147.55,225.25s-6.88,12.43-6.88,25.08l1.08,2.11,2.16-2s.43-15.56,6.13-24.74Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M108.61,195.92a7.58,7.58,0,1,1-7.58-7.58A7.53,7.53,0,0,1,108.61,195.92Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M108,195.92a7.59,7.59,0,1,1-7.58-7.58A7.53,7.53,0,0,1,108,195.92Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M107.36,195.92a6.9,6.9,0,1,1-6.9-6.9A6.86,6.86,0,0,1,107.36,195.92Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M103.33,194.32a2.88,2.88,0,1,1-2.87-2.87A2.88,2.88,0,0,1,103.33,194.32Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M104.76,201.31a6.89,6.89,0,0,1-8.61,0,4.39,4.39,0,0,1,7.41-2.25A4.3,4.3,0,0,1,104.76,201.31Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M100.61,221.84a6.9,6.9,0,1,1-6.9-6.9A6.9,6.9,0,0,1,100.61,221.84Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M100.09,221.84a6.9,6.9,0,1,1-6.9-6.9A6.9,6.9,0,0,1,100.09,221.84Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M99.47,221.84a6.28,6.28,0,1,1-6.28-6.28A6.26,6.26,0,0,1,99.47,221.84Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 53.24,
    cy: 195.43,
    r: 2.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M97.11,226.74a6.27,6.27,0,0,1-7.85,0,4,4,0,0,1,7.85,0Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M106.12,224a1,1,0,0,1-.87-.54,1,1,0,0,1,.44-1.31l14.16-7-11.8-8.28a1,1,0,1,1,1.12-1.59l13.14,9.22a1,1,0,0,1,.41.87,1,1,0,0,1-.54.8l-15.63,7.75A.94.94,0,0,1,106.12,224Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M109.93,223a3.81,3.81,0,1,1-3.81-3.82A3.81,3.81,0,0,1,109.93,223Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M112.57,206.05a4,4,0,1,1-4-4A4,4,0,0,1,112.57,206.05Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M127,215.27a5.26,5.26,0,1,1-5.26-5.26A5.26,5.26,0,0,1,127,215.27Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 117.04,
    y: 222.58,
    width: 18.31,
    height: 24.94,
    rx: 0.63,
    transform: "translate(78.16 -56.56) rotate(26.49)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 121.88,
    y: 227.08,
    width: 16.06,
    height: 1.04,
    rx: 0.17,
    transform: "translate(75.23 -59) rotate(26.49)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 120.02,
    y: 230.8,
    width: 16.06,
    height: 1.04,
    rx: 0.17,
    transform: "translate(76.7 -57.78) rotate(26.49)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 118.17,
    y: 234.52,
    width: 16.06,
    height: 1.04,
    rx: 0.17,
    transform: "translate(78.16 -56.56) rotate(26.49)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 116.31,
    y: 238.24,
    width: 16.06,
    height: 1.04,
    rx: 0.17,
    transform: "translate(79.63 -55.34) rotate(26.49)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 114.46,
    y: 241.96,
    width: 16.06,
    height: 1.04,
    rx: 0.17,
    transform: "translate(81.09 -54.12) rotate(26.49)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M139.33,237.26l-2,4.33s11.23,10.61,14.81,12.11c1.57.66,4.42-.35,4.42-.35a6.59,6.59,0,0,0-.39-4.43C154.11,245.39,150,245.36,139.33,237.26Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M138.69,236.63a4,4,0,0,0-1.51-3.17l-.64,1.28.38,1Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M137.12,235.19l-5.73-4.48a.39.39,0,0,0-.52,0h0a.39.39,0,0,0,0,.54l3.31,3.06L130,231.13a.34.34,0,0,0-.47.05h0a.34.34,0,0,0,0,.47l3.47,3.5-3.5-2.78a.33.33,0,0,0-.46,0h0a.32.32,0,0,0,0,.44l3.34,3.39-3.23-2.59a.37.37,0,0,0-.55.14h0a.34.34,0,0,0,.08.39l5.71,5.57,1.76-2Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M139.33,237.26l-1.7-1.69a2.41,2.41,0,0,0-4,1,.3.3,0,0,0,0,.1,2.85,2.85,0,0,0,0,1.3,3.2,3.2,0,0,0,2,2.58l1.73,1Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M155.92,214.12a37.91,37.91,0,0,0,0,9.11l-8.17.22a47.94,47.94,0,0,0,1.67-9.16Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M159.71,248c-.63,3.08-1.77,3.94-1.81,4a4.56,4.56,0,0,0-.09-1.62c-.36-1.65-1.67-4.11-6.2-5.29l-.4-.11v-.81a.32.32,0,0,1,.29-.32l.45,0a8.29,8.29,0,0,1,7.24,3.06,6.1,6.1,0,0,1,.43.65.65.65,0,0,1,.08.17h0A.78.78,0,0,1,159.71,248Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M148.94,225.8l.09-2.17c2.7-.51,6.46-.66,7.37-2.93a4.58,4.58,0,0,1,.78,2.79S156,225.8,148.94,225.8Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M149,223.63a1.15,1.15,0,0,1-.95-1.38c-.69.21-1.45.62-1.53,1.26a2.86,2.86,0,0,0,2.39,2.29C149,224.77,149,223.63,149,223.63Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M149.23,226.33h-.87a.84.84,0,0,1-.81-1.08l.28-.95a.83.83,0,0,1,.81-.6h.87a.84.84,0,0,1,.81,1.08l-.28.94A.84.84,0,0,1,149.23,226.33Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 139.62,
    y: 238.79,
    width: 2.61,
    height: 5.56,
    rx: 0.38,
    transform: "matrix(0.8, 0.6, -0.6, 0.8, 133.66, -61.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M143.06,241.82l-1.17,1.63a.65.65,0,0,1-.92.15l-1.85-1.37a.65.65,0,0,1-.15-.92l1.16-1.63a.67.67,0,0,1,.92-.15l1.85,1.37A.66.66,0,0,1,143.06,241.82Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M141.34,243.29a.19.19,0,0,1-.12,0l-1.84-1.37a.22.22,0,0,1-.06-.31l1.17-1.63a.21.21,0,0,1,.19-.1.28.28,0,0,1,.12,0l1.84,1.37a.22.22,0,0,1,.1.15.21.21,0,0,1,0,.17l-1.16,1.63A.25.25,0,0,1,141.34,243.29Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M156.09,264.7c-6.83,3.13-25,1.39-27.91,0-.12.37-.24.75-.36,1.15a24.87,24.87,0,0,0,7.56,2.25l-4.08,23.34c1-4.52,2.76-12.14,5.62-23.14a47.33,47.33,0,0,0,9,.08,69.91,69.91,0,0,0,9.58-1.46c.23-.78.43-1.52.58-2.23Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M149,202.51s-2.27-.6-3.3,0c-1.48.79-2.46,3.35-.92,6.08C147,207.84,149.4,203.63,149,202.51Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M142.81,215.66a13.21,13.21,0,0,0,1.22,6.62c.16.34.61.45,1.26.58,2.11.42,5.25-.41,7.89-2.05.89-.73,1.29-2.3,2.41-3.88,1.28-1.83,4.15-2.84,4.44-4.13,1-4.38-1.2-7.83-7.16-9.43-4.66-1.24-7.62,1.23-8.13,5.59,0,.27-.07.53-.1.77s0,.29-.07.43,0,.23-.07.35l0,.16-.12.55c0,.13-.07.25-.1.37l0,.08C143.71,213.43,143.08,213.87,142.81,215.66Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M146.31,216.94a3.49,3.49,0,0,0-.43-.07h-.21a.34.34,0,0,0-.19.09.26.26,0,0,1,.17-.14.63.63,0,0,1,.23,0l.22.05Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M144.43,216h0a2.13,2.13,0,0,0,.61-.51,6.17,6.17,0,0,0,.48-.66,15.36,15.36,0,0,0,.78-1.44c.23-.49.45-1,.65-1.5s.41-1,.6-1.53c-.14.53-.31,1-.5,1.57s-.39,1-.62,1.52c-.12.25-.24.5-.37.74s-.27.49-.42.72a6.45,6.45,0,0,1-.51.66,2.21,2.21,0,0,1-.63.5l0,.12a.83.83,0,0,0,0,.15,1.42,1.42,0,0,0,.1.29,2.54,2.54,0,0,0,.16.28,1.5,1.5,0,0,0,.2.24,1,1,0,0,1-.22-.23,1.51,1.51,0,0,1-.18-.26,1.94,1.94,0,0,1-.13-.3.88.88,0,0,1-.05-.15.94.94,0,0,1,0-.16A0,0,0,0,1,144.43,216Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M145.9,205.5c.65-.3,4.65-.88,6.19,1.19,3.94,5.3,0,6,3.08,8.19l2.86,1.51a5.56,5.56,0,0,0,2.91-3.57c.56-2.5.9-6-1.4-7.65s-7.78-6.21-11.89-2.36A5,5,0,0,0,145.9,205.5Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M154.85,215.35c-.68,1.23-.55,2.57,0,3a3,3,0,0,0,3.27-1.14c.69-1.23.51-2.63-.4-3.14S155.54,214.12,154.85,215.35Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M155.43,218.05A1.9,1.9,0,0,1,155,218l-.14-.06c-.37-.29-.47-1.38.2-2.46a2.11,2.11,0,0,1,2.12-1.16,1.39,1.39,0,0,1,.28.12,1.2,1.2,0,0,1,.47.62.07.07,0,0,1,0,.09.08.08,0,0,1-.09,0,1,1,0,0,0-.41-.54.86.86,0,0,0-.24-.11,2,2,0,0,0-2,1.1,2.09,2.09,0,0,0-.23,2.26h0a.23.23,0,0,0,.09,0,2,2,0,0,0,.62,0,.08.08,0,0,1,.08.07.08.08,0,0,1-.07.08Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M149.81,212c-.12.52-.49.89-.83.81s-.53-.56-.41-1.08.49-.89.83-.81S149.92,211.47,149.81,212Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M145.94,211.13c-.1.44-.41.74-.69.68s-.44-.47-.34-.9.41-.74.69-.68S146,210.7,145.94,211.13Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M148.85,209.13a5.21,5.21,0,0,1,2.19,1,4.88,4.88,0,0,1,1.47,1.84.23.23,0,0,1-.41.2,4.47,4.47,0,0,0-2.34-2,4.23,4.23,0,0,0-1-.25.38.38,0,0,1-.35-.4.37.37,0,0,1,.43-.34Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M144.58,209.22a3.12,3.12,0,0,1,1.86-.49,4.64,4.64,0,0,1,.64,0,.36.36,0,0,1,.33.39.37.37,0,0,1-.47.32,5.39,5.39,0,0,0-1.12-.21,2.89,2.89,0,0,0-.83.08l-.27.1a.13.13,0,0,1-.14-.22Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M146,219.52a.15.15,0,0,1,.06-.29,3,3,0,0,0,1.85-.3.16.16,0,0,1,.21,0,.16.16,0,0,1,0,.21,3.22,3.22,0,0,1-2.07.35Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M156.09,264.69h0c-6.83,3.13-25,1.39-27.91,0h0a5.28,5.28,0,0,1,.44-2.47c16.89,5,27.69,0,27.69,0A3.28,3.28,0,0,1,156.09,264.69Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M139.87,267.32h-.07l-3.39-.31a.74.74,0,0,1-.51-.27.79.79,0,0,1-.17-.54l.21-2.24a.74.74,0,0,1,.27-.51.71.71,0,0,1,.54-.17l3.4.32a.69.69,0,0,1,.5.26.74.74,0,0,1,.17.55l-.21,2.24A.74.74,0,0,1,139.87,267.32Zm-3.19-3.54a.3.3,0,0,0-.15.05.3.3,0,0,0-.08.16l-.21,2.25a.27.27,0,0,0,.06.17.28.28,0,0,0,.15.08l3.4.31a.24.24,0,0,0,.26-.21l.2-2.24a.23.23,0,0,0-.21-.25l-3.4-.32Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M140.21,265.55l-1.3-.09a.26.26,0,0,1-.24-.27h0A.27.27,0,0,1,139,265l1.29.09Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M164.34,233.39c-.89,2.92-2.19,7.8-3.3,10.92a2.73,2.73,0,0,1-1.34,3.34.65.65,0,0,0-.08-.17,6.1,6.1,0,0,0-.43-.65,8.29,8.29,0,0,0-7.24-3.06l-.45,0,.11,0a10.05,10.05,0,0,1,3.95-.1,3.94,3.94,0,0,0,4.35-2.41l2.21-5.53c2.77-6.9,1.12-9.67.49-10.4a3.68,3.68,0,0,1,2.4,3.47A15.17,15.17,0,0,1,164.34,233.39Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M141.33,298.07a39.41,39.41,0,0,1-1.15,7.39c-2.12,6.77-11.81,27.14-11.81,27.14a11.16,11.16,0,0,1-5.31.42c-2.76-.52-3.47-2.25-3.47-2.25l.12-.3c2.33,1.25,5.47,1.41,8.78-2.78C135.27,319.12,141.33,298.07,141.33,298.07Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M151.64,321.57c-.29-.57-5.92-11.92-10.12-16.91a22.92,22.92,0,0,1-4.33,10.86l-.63-.9c1.59-3.68,3-7.07,3.62-9.16a35.91,35.91,0,0,0,1.11-6.91q.26.43.45.84C143.52,303,151.32,320.85,151.64,321.57Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M368.88,79.75l-17.66-5.46,3.65-11.79a9.24,9.24,0,0,1,11.56-6.1h0A9.24,9.24,0,0,1,372.53,68Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M391.75,119.84l-7.92,25.63c-9.32-6.28-23.05-12.63-38.89-17.53s-30.76-7.4-42-7.49l7.93-25.63a42.33,42.33,0,0,1,80.88,25Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M393.79,170.65c3.89-12.58-9.9-25.39-9.9-25.39l-.29.06c-9.31-6.23-23-12.52-38.66-17.38s-30.52-7.36-41.73-7.48l-.2-.21S284.39,123,280.5,135.62l23,7.1,1.66-5.36,67.33,20.82-1.66,5.37Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-36",
    cx: 337.15,
    cy: 153.13,
    rx: 17.51,
    ry: 59.29,
    transform: "translate(51.29 405.04) rotate(-72.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M382.56,167.18c-1.5,4.87-18.56,4-39.76-1.55-2.85-.75-5.77-1.58-8.74-2.5s-5.86-1.88-8.63-2.87c-20.65-7.36-35.2-16.3-33.7-21.17,1.37-4.44,15.66-4.14,34.23.18,4.55,1,9.35,2.35,14.28,3.87s9.62,3.16,14,4.86C372,154.93,383.93,162.75,382.56,167.18Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 387.63,
    cy: 98.17,
    r: 24.33,
    transform: "translate(56.13 346.87) rotate(-57.4)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 385.02,
    cy: 98.09,
    r: 24.33,
    transform: "translate(81.95 370.84) rotate(-62.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M404.9,98.69a19.89,19.89,0,1,1-19.27-20.48A19.89,19.89,0,0,1,404.9,98.69Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M395.31,103.28c-.13,4.42-3.66,8.36-11.12,8.14a18,18,0,0,1-9.93-3.12l2.51-4.57a12.72,12.72,0,0,0,7.42,2.58c3,.1,4.95-1.08,5-3.22s-1.36-3.27-4.81-3.37l-2.77-.09.12-4,5.58-5.94-11.17-.34.15-4.87,18.37.55L394.55,89l-6.13,6.57C393.12,96.42,395.43,99.41,395.31,103.28Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M354.21,148l-2.53,8.18a14.79,14.79,0,0,1-28.25-8.74l2.53-8.17c4.55,1,9.35,2.35,14.28,3.87S349.86,146.3,354.21,148Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M542.55,215.61a14.31,14.31,0,0,1,2.8.8,3.45,3.45,0,0,1,2.14,3.17,6.05,6.05,0,0,1-1.43,4.28,3.26,3.26,0,0,1-1.94,1.12l-.09,0a4,4,0,0,1-4.56-4.54c.06-.46.13-.94.19-1.4A4.85,4.85,0,0,1,542.55,215.61Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M533.18,342c-.27,2.84-.54,6.64-.79,10.73l-.84.43-3.19,1.65-.56-.83c0-3-.48-8.53-.71-11.2,0-.2,0-.38-.05-.54A13.65,13.65,0,0,0,533.18,342Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M533.26,355.87a4.2,4.2,0,0,1-.33,1.7.75.75,0,0,1-.72.55h-11a1,1,0,0,1-.63-.23.94.94,0,0,1-.32-.59c-.16-1,.41-1.5,1.34-1.81a21.62,21.62,0,0,0,5.63-2.4.91.91,0,0,1,.89-.1c1.21.47,1.08.39,2.19-.16a4.72,4.72,0,0,1,1.3-.48.84.84,0,0,1,.79.14.42.42,0,0,1,.12.24A13.51,13.51,0,0,1,533.26,355.87Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M546.55,275.08v8l-9.27,24a31.68,31.68,0,0,0-2.06,13.07c.41,7.42-.4,13.51-1.75,21.68l-.29.08c-.55.13-1.07.23-1.57.31s-.84.11-1.23.14a14,14,0,0,1-1.57,0c-.47,0-.89-.07-1.25-.13a7.91,7.91,0,0,1-1.57-.41l-.17-.08c-.61-8.13-1.72-17.36-2.43-22.89-.08-.56-.14-1.13-.19-1.7-.11-1.09-.18-2.17-.21-3.26a52,52,0,0,1,.1-5.58c.57-7.92,1.81-22.65,3.8-33.33Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M528.81,342.46c-.47,0-.89-.07-1.25-.13a132.86,132.86,0,0,1-2.4-24.14,141.29,141.29,0,0,1,1.52-21.81,111.89,111.89,0,0,1,4.69-20.22l1.16.42a111.78,111.78,0,0,0-4.64,20A139.17,139.17,0,0,0,528.81,342.46Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M573.17,346.09l-.41.65-1.92,3-1.43-.33c-1.55-2.39-3.48-5-5-7.17l-.64-.89a10.91,10.91,0,0,0,5.32-4C570.14,339.73,571.65,343.14,573.17,346.09Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M576.55,351.18l-7.35,6.94h-3.41a1.13,1.13,0,0,1-1.12-1.12,1.57,1.57,0,0,1,.73-1.32l1.28-.79a7.83,7.83,0,0,0,2.73-5.51,4.1,4.1,0,0,0,2-2.55,1.11,1.11,0,0,1,1-.76,3.07,3.07,0,0,1,.74,0l.39.21a6.25,6.25,0,0,1,2.91,3.33l.25.69A.83.83,0,0,1,576.55,351.18Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M569.05,337.31h0l-.41.51a14.19,14.19,0,0,1-2.19,2.08,9.75,9.75,0,0,1-1.18.77,7.94,7.94,0,0,1-1.53.65,4,4,0,0,1-.68.14c-2.31-3.37-11.54-16-12-16.6l0,0c-3.17-4.06-5.51-7.38-6.81-10.85-.06-.17-6-17.1-8.11-33.16-.17-1.25-.3-2.5-.41-3.73-.06-.68-.11-1.36-.15-2H553.4c.07.26.13.53.19.79a28.72,28.72,0,0,1,.53,7.38,40,40,0,0,0,.39,8.18l.78,15.24a14.7,14.7,0,0,0,3.23,8.46,39.15,39.15,0,0,1,3,4.27,27.49,27.49,0,0,1,1.69,3.47v0C563.4,323.27,567.06,331.54,569.05,337.31Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M527.67,232.4c-1.4,5.65-4.21,10.19-4.21,14.85h5.38l-.13-14.85Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M542.8,227.37h-7.32s2.3-5.36,2.3-16.63h4.1C541.82,216.51,542.8,227.37,542.8,227.37Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M551.42,236.13a37.49,37.49,0,0,1-.25,4.15c-.28,2.45-.76,4.59-1.17,6.85a39.63,39.63,0,0,0-.15,14.2H529.4c-.2-10.36-2-12.8-2.51-18.87-.21-2.42,1.06-6.12.78-10.06a31.94,31.94,0,0,1,7.81-5h7.32a37.41,37.41,0,0,1,7.12,3.58A14.92,14.92,0,0,1,551.42,236.13Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M566.45,339.9a9.75,9.75,0,0,1-1.18.77c-1-1.24-2.14-2.7-3.36-4.34A127.24,127.24,0,0,1,548.51,314,67.08,67.08,0,0,1,543,288.77a65.74,65.74,0,0,1,.58-11.79l1.39.23a69.86,69.86,0,0,0,4.84,36.18A125.17,125.17,0,0,0,563,335.47C564.28,337.16,565.44,338.65,566.45,339.9Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "489.45 236.38 486.94 250.13 513.46 250.13 509.9 236.38 489.45 236.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.47,275.13H526.83v-.06l2.51-13.79h20.54v0ZM527,275h26.39l-3.53-13.65H529.44Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 474.44,
    y: 222.3,
    width: 59.74,
    height: 32.29,
    rx: 0.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 476.83,
    y: 227.54,
    width: 22.65,
    height: 1.54,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 476.83,
    y: 234.84,
    width: 55.82,
    height: 1.54,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 476.83,
    y: 239.68,
    width: 55.82,
    height: 1.54,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 476.83,
    y: 244.53,
    width: 55.82,
    height: 1.54,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 476.83,
    y: 249.38,
    width: 55.82,
    height: 1.54,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M568.45,254c-.84,6.25-8.7,25.5-8.7,25.5h-1.84l-.62-2,.35-3.92.59-4.57,3.12-9.09-.69-12.75h4.28S569.29,247.78,568.45,254Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M551.17,240.28c-.28,2.45-.78,4.71-1.19,7h-8.86a6.34,6.34,0,0,0,4.33-7.86,5.18,5.18,0,0,1,2-5.92Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M560.15,270.74l-.4,1.23h0l-3.45-1,.27-1.2A6,6,0,0,0,560.15,270.74Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M555.7,272.3,553.44,276a.26.26,0,0,0,0,.3h0a.55.55,0,0,0,.82.09l2.09-1.83Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M555.54,273.36l-.62,6.65a.4.4,0,0,0,.29.44h0a.36.36,0,0,0,.39-.31l.77-3.7-.35,4a.37.37,0,0,0,.26.41h0a.33.33,0,0,0,.38-.3l.69-3.87-.24,3.68a.38.38,0,0,0,.28.41h0a.35.35,0,0,0,.38-.32l.55-3.73-.22,3.45a.4.4,0,0,0,.3.42h0a.35.35,0,0,0,.39-.32l.79-5.95-1.17-.72Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M556.3,271l-.44.88a4.73,4.73,0,0,0-.13,3c.22.71.61,1.36,1.31,1.48a2,2,0,0,0,1.4-.34,3.54,3.54,0,0,0,1.31-3.12V272Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M521.18,248.76h0a.41.41,0,0,1-.52-.19l-.83-1.57a.46.46,0,0,1,.24-.65l.29-.11a.46.46,0,0,1,.61.31l.46,1.72A.41.41,0,0,1,521.18,248.76Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M522,248.7h0a.45.45,0,0,1-.51-.33l-.52-1.89a.51.51,0,0,1,.41-.64l.34-.05a.52.52,0,0,1,.59.49l.07,1.95A.44.44,0,0,1,522,248.7Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M522.93,248.71h0a.51.51,0,0,1-.47-.47l-.11-2.12a.55.55,0,0,1,.58-.58l.37,0a.55.55,0,0,1,.51.65l-.36,2.09A.51.51,0,0,1,522.93,248.71Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M523.8,248.7h0a.47.47,0,0,1-.33-.53l.34-2a.52.52,0,0,1,.66-.41l.33.1a.52.52,0,0,1,.34.7l-.78,1.86A.47.47,0,0,1,523.8,248.7Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M566.9,253.58c0,4.39-4.1,13.49-5.86,17.13l-.5,0c-.36,0-.7,0-1,0a5.82,5.82,0,0,1-3-1,1.75,1.75,0,0,1-.2-.16c3.13-12,5.1-14.74,3.38-17.69-1.24-2.11-5.93-5.59-8.83-7.61a10.09,10.09,0,0,1-4.34-8.61v-.24c.1-1.85,3.33-4.49,3.33-4.49h0C554.92,235.83,566.9,248.79,566.9,253.58Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M530.78,210.33a9.72,9.72,0,0,1-3.53,5.38c1.3.12,3.4-1.72,3.4-1.72s-.09,1.08-2.17,2.29a14.44,14.44,0,0,0,3.67-1.21c1.23-.69,1-3.58,1-3.58Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M529.7,220.19s0,.09,0,.14c.21,2,.77,5.13,1.75,6.09a10.47,10.47,0,0,0,8.14-2.51c.72-1.29.49-5.1,1-6.31,0,0,5-6.72,2.5-9.14a9.32,9.32,0,0,0-5.61-2.61,5.91,5.91,0,0,0-5.24,2.23,13.09,13.09,0,0,0-1.36,2.85,25.28,25.28,0,0,0-.07,4c0,.1,0,.2,0,.28h0a2.39,2.39,0,0,1-.19.87l-.06.17-.12.29c0,.1-.07.21-.11.32s-.08.25-.12.39c-.18.65-.35,1.41-.49,2.12a3.59,3.59,0,0,0,0,.46C529.69,220,529.7,220.07,529.7,220.19Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M530.92,220.73a2.14,2.14,0,0,1,1.43,1l-1.09,0A1.35,1.35,0,0,1,530.92,220.73Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M538.75,215.61c-.11-.1-.23-.19-.35-.28s-.24-.18-.37-.26a7.39,7.39,0,0,0-.76-.47l-.39-.22-.41-.2a7.14,7.14,0,0,0-.85-.33h-.42l-.34,0a3.72,3.72,0,0,0-.65.19,3.64,3.64,0,0,0-.59.3h0a.14.14,0,0,0,.1.25h0a6,6,0,0,1,.61-.12c.2,0,.4-.06.59-.08h.52l.8.29.82.33.83.31C538.18,215.44,538.46,215.53,538.75,215.61Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M532.18,224.08a4,4,0,0,1-.59,0s-.05,0,0-.06,0,0,.06,0a4.93,4.93,0,0,0,1.43,0,.05.05,0,0,1,0,.1A6.16,6.16,0,0,1,532.18,224.08Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M533,208a2.19,2.19,0,0,0-1.66-.3c-1,.88-1.38,3.16-.53,3.87a2.15,2.15,0,0,1,1.4-1.37Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M532.24,210.23a4.19,4.19,0,0,1,3.67.19c0,5.92,5.21,5.56,4.25,9.56a1.12,1.12,0,0,0,.73.41,4.53,4.53,0,0,0,.51,0,5.32,5.32,0,0,0,4.78-2.78,7.85,7.85,0,0,0,1-5.92,5.27,5.27,0,0,0-1.93-2.41s-1.5-5-6-5.32S531.59,206.36,532.24,210.23Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M532.3,214.59c.08,0,.14-.09.07-.15l-.09-.08-.34-.22a1.76,1.76,0,0,0-.37-.17,1.69,1.69,0,0,0-.4-.12h0a.35.35,0,0,0-.14.06.48.48,0,0,0-.11.09h0a.09.09,0,0,0,.1.14h0a.58.58,0,0,1,.18,0h0l.34.16.36.15.38.13Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M532.35,221.78h0l-1.09,0a.06.06,0,0,1-.06,0,1.4,1.4,0,0,1-.37-1,.14.14,0,0,1,0-.06,4.89,4.89,0,0,0,.86-1.39,10.51,10.51,0,0,0,.81-4.49.11.11,0,0,1,.09-.1h0a.09.09,0,0,1,.09.09,10.72,10.72,0,0,1-.82,4.57,5.37,5.37,0,0,1-.87,1.42,1.22,1.22,0,0,0,.29.8l1.06,0a.08.08,0,0,1,.08.09A.09.09,0,0,1,532.35,221.78Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M535.91,210.42a4.76,4.76,0,0,0,2.73,4.32c2.21,1.06,3.45,7.11.2,10,1.49-2.35,1.88-7.54-1-9.06C534.73,214,535.91,210.42,535.91,210.42Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M534.85,215.82c0,.45-.17.82-.38.82s-.38-.37-.38-.82.17-.83.38-.83S534.85,215.36,534.85,215.82Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M532,215.82c0,.45-.17.82-.38.82s-.38-.37-.38-.82.17-.83.38-.83S532,215.36,532,215.82Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M535.1,227.56a4.85,4.85,0,0,0,.38-1.11,18.42,18.42,0,0,1,7.55,0,4.16,4.16,0,0,0,.29,1.11S534.84,229.26,535.1,227.56Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M566.9,253.58c0,4.39-4.1,13.49-5.86,17.13l-.5,0c-.36,0-.7,0-1,0,1.52-2.74,7.38-13.83,5.61-19.09-2-6-15-20.45-15.22-20.67C554.92,235.83,566.9,248.79,566.9,253.58Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M569.05,337.31h0l-.41.51c-18-25.13-19.06-43.81-18.3-52.15a4.44,4.44,0,0,0-4.42-4.84h-9.77c-.06-.43-.11-.86-.16-1.29h18.1a33.26,33.26,0,0,1,0,3.71,40,40,0,0,0,.39,8.18l.78,15.24a14.7,14.7,0,0,0,3.23,8.46,39.15,39.15,0,0,1,3,4.27,27.49,27.49,0,0,1,1.69,3.47v0C563.4,323.27,567.06,331.54,569.05,337.31Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M553.55,96.66S542.13,96,534,97.48a12,12,0,0,0-8.67,6.55c-5.13,10.47-5.93,18.21-13.11,32.56-.6,1.19-2.1,2.16-1.36,3.87s6.17,3.32,7.84,2.32,1.66-3.34,2.31-4.49c5.22-9.07,10-13.83,13-18.2a23.94,23.94,0,0,0,2.54-4.76,5.79,5.79,0,0,1,5.62-3.7c6.37.23,17.87.47,24.72-.31l2.92-14.43Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M535,143.91c0,.19,0,.37,0,.55a8.22,8.22,0,0,1-.43,2.14h0a.64.64,0,0,1-.61.44H518.6a.87.87,0,0,1-.62-.25,1.33,1.33,0,0,1-.14-.19.88.88,0,0,1-.11-.42,2.19,2.19,0,0,1,1.62-2.12,27.46,27.46,0,0,0,8.31-3.81c.12-.09.24-.18.35-.28l6.4.26.42,2A8.4,8.4,0,0,1,535,143.91Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M587.89,105.09c-.55,3.67-4.14,5.93-13.23,6.76-2.65.25-5.76.37-9.4.37a36.73,36.73,0,0,1-8.08-1.28h0a2.56,2.56,0,0,0-.47,0h0a2.07,2.07,0,0,0-2,1.6,23.47,23.47,0,0,1-3.35,7.6c-1.75,2.55-4.15,5.49-6.87,9.3-1.86,2.6-3.88,5.6-6,9.16h0l-.3.51c-.66,1.15-.64,3.49-2.31,4.49a2,2,0,0,1-.91.23c-2.18.11-6.2-1.84-6.84-3.32A3.49,3.49,0,0,1,528,140c-.29-1.42,1-2.31,1.52-3.38,7.43-14.86,8-22.63,13.67-33.68a9.81,9.81,0,0,1,6.53-5.11h.06A44.19,44.19,0,0,1,555.2,97h0l1.26-.11a121.11,121.11,0,0,1,14.37-.18l8.7.12,7.64-.18.09.25A19,19,0,0,1,587.89,105.09Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M511.07,140.26s-.75-.45,1.27-.67,6.33.47,5.24,2.73A10.84,10.84,0,0,1,511.07,140.26Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M570.52,86,564,83.56c-.27-2.11-.94-5.47-1.59-9.17-.11-.63-.22-1.28-.33-1.93a72.16,72.16,0,0,1-1.13-11.09,7,7,0,0,1,.16-1.36,4.48,4.48,0,0,1,8.76-.35,6,6,0,0,1,.17.73C572.11,71.56,570.52,86,570.52,86Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M569.6,86.3s-.46-5.37-9.13-1.58c-3.54,1.55-7.16,4.85-19.23,10.26l5.38,1.57,16.22-4.14c3.26-1.31,6.35-4.23,6.76-6.11Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M565.11,73.18s-2.2.79-3.11.22c-.14-.61-.28-1.2-.4-1.77-2.57-12,.79-14.89.79-14.89l2.46,14.88Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M517.59,143.91a8.48,8.48,0,0,1-.24,2q-.09.34-.21.69a.63.63,0,0,1-.61.44h-15.4a.81.81,0,0,1-.76-.52.72.72,0,0,1-.06-.29v0a2.19,2.19,0,0,1,1.62-2.12,31,31,0,0,0,7.14-3,6.82,6.82,0,0,1,3.79-1l2.14.09a2.53,2.53,0,0,1,1.55.6,2.57,2.57,0,0,1,.86,1.43A8.4,8.4,0,0,1,517.59,143.91Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M588.06,94c-.23,1.57-.44,2.45-.44,2.45-5.76,7.3-32.2.13-32.2.13a8.69,8.69,0,0,0,2.31-1.07c.62-.4,1.43-.84,2.3-1.4,2.71-1.76,6-4.71,5.91-11.1,0-.53,0-1.09-.1-1.67a33,33,0,0,0-1.94-7.83c-.14-.4-.28-.81-.43-1.22l-.21-.62a30.64,30.64,0,0,1-2.13-10.11v-.1a9.62,9.62,0,0,1,1.51-5.13,10.17,10.17,0,0,1,3.58-3.44,13,13,0,0,1,4.34-1.46l.9.29c3.95,1.33,5.56,2.3,6.7,3.54a6.27,6.27,0,0,1,.42.48l.45.58a49.68,49.68,0,0,1,8.86,21.53c.25,1.6.43,3.15.53,4.61A54.23,54.23,0,0,1,588.06,94Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M587.89,77.84l-8.43,4.23-1.41-3.35a3.79,3.79,0,0,0-4.4-2.19c-2.53.64-6.08,1.15-8.36-.13a12,12,0,0,0,4.4,0,4.72,4.72,0,0,0,3.18-7,36.13,36.13,0,0,1-3.27-6.95,8.36,8.36,0,0,1,1.74-7.38l7.24.68.45.58A49.55,49.55,0,0,1,587.89,77.84Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M584.9,65.81a11.6,11.6,0,0,1-4.22,3.1,17.63,17.63,0,0,1-3.7,1.41c-1,.22-1.68.19-1.84-.15h0c-.14-.26.27-.67.94-1.2,1-.81,2.65-1.89,4-3.15,1.67-1.59,3.29-1.56,4.2-1.16a1.56,1.56,0,0,1,.71.53h0v0h0A.65.65,0,0,1,584.9,65.81Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M571.06,53a17.21,17.21,0,0,1-6.63,4,1.62,1.62,0,0,1-.49.08,1.51,1.51,0,0,1-1.3-.73,10.09,10.09,0,0,1,3.58-3.44,13,13,0,0,1,4.34-1.46l.9.29A1.5,1.5,0,0,1,571.06,53Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M566.55,45a20.63,20.63,0,0,0,4,6.38.77.77,0,0,1,0,1.08,16.65,16.65,0,0,1-6.36,3.81.84.84,0,0,1-1.06-.54,24.32,24.32,0,0,0-2.23-5.12C560.57,48.37,566.55,45,566.55,45Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M552.94,37.42s-2.29.75-2.87,1.79c-.84,1.5-.27,4.25,2.57,5.74C554.13,43.15,553.88,38.18,552.94,37.42Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M554.89,52.18a13.35,13.35,0,0,0,4.73,5c.31.21.76,0,1.4-.2,2.05-.81,4.3-3.26,5.66-6.14.35-1.12-.17-2.7-.09-4.68.09-2.29,2-4.75,1.53-6-1.59-4.31-5.37-6.07-11.39-4.13-4.71,1.51-5.88,5.29-3.9,9.32.12.25.24.49.34.72l.18.4c0,.12.09.23.13.34a1.11,1.11,0,0,1,.07.16c.07.19.14.37.19.54s.09.26.13.38a.24.24,0,0,0,0,.08C554.42,49.77,554.13,50.5,554.89,52.18Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M558.61,51.35l-.22.08-.2.09a.94.94,0,0,0-.18.12.32.32,0,0,0-.1.19.29.29,0,0,1,.07-.22.52.52,0,0,1,.19-.14A1.07,1.07,0,0,1,558.61,51.35Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M556.46,51.57h0a2,2,0,0,0,.24-.78,5.69,5.69,0,0,0,0-.83,15.85,15.85,0,0,0-.13-1.67c-.08-.55-.17-1.11-.27-1.66s-.21-1.1-.33-1.65c.17.54.31,1.08.44,1.63s.23,1.1.31,1.66c0,.28.07.56.09.84s0,.57,0,.85a4.8,4.8,0,0,1-.07.85,2.25,2.25,0,0,1-.23.72.11.11,0,0,0,0,.12l0,0,.11.11L557,52a2.69,2.69,0,0,0,.29.16,1.71,1.71,0,0,0,.3.09,1.16,1.16,0,0,1-.31-.07A1.36,1.36,0,0,1,557,52l-.28-.18a.69.69,0,0,1-.13-.11l-.12-.11S556.45,51.59,556.46,51.57Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M551.91,41.73c.39-.62,3.51-3.34,6-2.42,6.35,2.38,3.34,5.2,7.2,5.34l3.3-.28a5.71,5.71,0,0,0,.53-4.69c-.91-2.46-2.55-5.65-5.45-5.81s-10.14-1-11.55,4.57A5.11,5.11,0,0,0,551.91,41.73Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M565.08,45.23c.09,1.44.95,2.53,1.66,2.56a3,3,0,0,0,2.18-2.8c-.09-1.43-1-2.55-2.08-2.48S565,43.8,565.08,45.23Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M566.44,47.25h0a.07.07,0,0,1-.06-.07.06.06,0,0,1,.06-.06.21.21,0,0,0,.1,0,2.44,2.44,0,0,0,1.41-2c-.07-1-.71-1.86-1.41-1.82a.09.09,0,0,1-.07-.06.07.07,0,0,1,.06-.07h.06c.75,0,1.42.87,1.48,2a2.57,2.57,0,0,1-1.49,2.15Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M558.87,45.15c.19.51.08,1-.26,1.15s-.76-.19-1-.7-.08-1,.26-1.16S558.68,44.63,558.87,45.15Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M555.07,46.55c.16.43.06.87-.22,1s-.64-.16-.8-.59-.06-.86.22-1S554.91,46.12,555.07,46.55Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M556.47,43.21a5.3,5.3,0,0,1,2.43-.35,5,5,0,0,1,2.29.77.23.23,0,0,1-.24.4,4.51,4.51,0,0,0-3.16-.46,4.17,4.17,0,0,0-1,.32.38.38,0,1,1-.34-.68Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M552.84,45.66a3.22,3.22,0,0,1,1.32-1.46,6.38,6.38,0,0,1,.57-.32.38.38,0,0,1,.51.15.38.38,0,0,1-.23.54,5.1,5.1,0,0,0-1.08.44,2.7,2.7,0,0,0-.67.53,1.13,1.13,0,0,0-.17.23c-.09.14-.31,0-.25-.11Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M559.8,53.72a.15.15,0,0,1-.11-.27,3.11,3.11,0,0,0,1.43-1.3.15.15,0,0,1,.28.12,3.29,3.29,0,0,1-1.59,1.45Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M587.62,96.44c-5.76,7.3-32.2.13-32.2.13a8.69,8.69,0,0,0,2.31-1.07C563,96,575.87,97,582.81,96.59a5,5,0,0,0,4.66-4.87V91.6a3.19,3.19,0,0,0-4.58-2.9L572,94h-6.64l2.41-3.42s6.74-3.36,7.1-3.57,9.07-5.65,9.07-5.65l4.48,1.12A49.44,49.44,0,0,1,587.62,96.44Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M591.14,79.35l-4.41.29-3.07.2s-3.32-4.52-6.68-9.52l-.15-.22L576.08,69c1-.81,2.65-1.89,4-3.15,1.67-1.59,3.29-1.56,4.2-1.16l.27.5.36.65c.06.13.13.26.2.38A138.25,138.25,0,0,1,591.14,79.35Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M591.14,79.35c0,1.93-1.64,3.72-4.54,5.7l-18,9.22-.87.45-2.2-3.45c10.61-7.89,13.36-11.38,16.91-12.91a9.11,9.11,0,0,1,2-.61h0A8.35,8.35,0,0,1,591.14,79.35Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "525.62 66.32 523.99 66.58 525.99 70.34 527.82 69.77 525.62 66.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M579.42,95a1.65,1.65,0,0,1-1.65,1.65H540.64V94h37.81a1,1,0,0,1,.69.29A.94.94,0,0,1,579.42,95Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M554,75.18H528.89A1.22,1.22,0,0,0,527.82,77L538.23,96.6h28.4L555.88,76.31A2.13,2.13,0,0,0,554,75.18Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M565.57,96.6H538.31a1.91,1.91,0,0,1-1.68-1L526.76,77a1.21,1.21,0,0,1,1.07-1.78h25.11a2.14,2.14,0,0,1,1.88,1.13Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M548,85.88c.6,1.38-.83,2.5-3.2,2.5s-4.78-1.1-5.38-2.48.84-2.5,3.21-2.5S547.44,84.5,548,85.88Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M585,65.19a1.56,1.56,0,0,0-.71-.53,3.43,3.43,0,0,0-3,.26,5.72,5.72,0,0,0-1.21.9c-1.34,1.26-3,2.34-4,3.15a4.94,4.94,0,0,0-.76.68c-.18.21-.25.39-.18.52a14.22,14.22,0,0,1-.93-1.22c-.14-.2-.3-.41-.46-.65a8.91,8.91,0,0,1,.79-.7c1.17-.92,3-2.15,4.55-3.58a6.35,6.35,0,0,1,1.56-1.12,4,4,0,0,1,2.91-.32l.78,1.4h0C584.7,64.65,584.93,65.1,585,65.19Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M583.56,62.58a4,4,0,0,0-2.91.32A6.35,6.35,0,0,0,579.09,64c-1.52,1.43-3.38,2.66-4.55,3.58a8.91,8.91,0,0,0-.79.7c-1.56-2.27-3.88-6.21-3.88-9.54a4.89,4.89,0,0,1,2.56-4.52h0l.09-.06h0a4.73,4.73,0,0,1,5.68,1A36.58,36.58,0,0,1,583.56,62.58Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M585.1,66.19c-.07-.12-.14-.25-.2-.38l-.63-1.15c-.91-.4-2.53-.43-4.2,1.16-1.34,1.26-3,2.34-4,3.15l.75,1.13c1.06-.42,3.49-1.5,4.06-2.85a1.72,1.72,0,0,1,.93-.91A2.46,2.46,0,0,1,585,67.52l4.27,8.73a.9.9,0,0,1-.94,1.29,7.61,7.61,0,0,0-3.86.21,8.35,8.35,0,0,1,6.63,1.6A138.25,138.25,0,0,0,585.1,66.19Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M591.14,79.35c0,1.93-1.64,3.72-4.54,5.7L569.23,94h-1.46S589.73,82.58,591.14,79.35Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M587.89,105.09c-.55,3.67-4.14,5.93-13.23,6.76A24.28,24.28,0,0,0,581,109.7a4.3,4.3,0,0,0-2.43-8.07C566.45,102.72,555.2,97,555.2,97h0l1.26-.11c4.84,1.2,25.16,5.82,30.8,0A19,19,0,0,1,587.89,105.09Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M556.67,110.89a2.07,2.07,0,0,0-2,1.6,23.47,23.47,0,0,1-3.35,7.6c-1.75,2.55-4.15,5.49-6.87,9.3,4.47-7.92,9.1-17.54,9.1-17.54s-3.09-2.08-3.09-4.63A8,8,0,0,0,556.67,110.89Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M583.56,62.58a4,4,0,0,0-2.91.32c-3.18-9.1-8.22-8.66-8.22-8.66h0l.09-.06h0a4.73,4.73,0,0,1,5.68,1A36.58,36.58,0,0,1,583.56,62.58Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M585,65.19a1.56,1.56,0,0,0-.71-.53,3.43,3.43,0,0,0-3,.26c-.2-.72-.41-1.39-.63-2a4,4,0,0,1,2.91-.32l.78,1.4h0C584.7,64.65,584.93,65.1,585,65.19Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M516.7,145.47a.92.92,0,0,1,.44,1.13h0a.63.63,0,0,1-.61.44H501.12a.58.58,0,0,1-.3-1.06c.64-.42,2.2-.89,5.95-.6C512.37,145.81,514.79,144.52,516.7,145.47Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M534.56,146.6h0a.64.64,0,0,1-.61.44H518.6a.87.87,0,0,1-.62-.25,1.33,1.33,0,0,1-.14-.19Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M535,143.91c0,.19,0,.37,0,.55-5.5-.13-7-3-7.33-4.21.12-.09.24-.18.35-.28a3.49,3.49,0,0,0,.16.49c.64,1.48,4.66,3.43,6.84,3.32Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M563.9,73.5a3.44,3.44,0,0,1-1.69,0l-.21-.1c-.14-.61-.28-1.2-.4-1.77.44,0,1,0,1.66,0l.21.62C563.62,72.69,563.76,73.1,563.9,73.5Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M565.94,83c-.43-2.63-1.13-5.4-1.57-7.07a2.09,2.09,0,0,0-2-1.54h0l-.15-.89a3.44,3.44,0,0,0,1.69,0,33,33,0,0,1,1.94,7.83C565.9,81.91,565.93,82.47,565.94,83Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M482,126.69a19.15,19.15,0,1,1-19.15-19.15A19.08,19.08,0,0,1,482,126.69Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M480.51,126.69a19.15,19.15,0,1,1-19.15-19.15A19.08,19.08,0,0,1,480.51,126.69Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M478.79,126.69a17.43,17.43,0,1,1-17.43-17.43A17.4,17.4,0,0,1,478.79,126.69Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M468.62,122.64a7.26,7.26,0,1,1-7.26-7.26A7.26,7.26,0,0,1,468.62,122.64Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M472.24,140.3a17.4,17.4,0,0,1-21.76,0,11.09,11.09,0,0,1,21.76,0Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M463.3,192.14a17.43,17.43,0,1,1-17.43-17.43A17.38,17.38,0,0,1,463.3,192.14Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M462,192.14a17.43,17.43,0,1,1-17.43-17.43A17.38,17.38,0,0,1,462,192.14Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M460.42,192.14a15.87,15.87,0,1,1-15.86-15.87A15.82,15.82,0,0,1,460.42,192.14Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M451.17,188.46a6.61,6.61,0,1,1-6.61-6.61A6.6,6.6,0,0,1,451.17,188.46Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M454.46,204.53a15.87,15.87,0,0,1-19.81,0,10.1,10.1,0,0,1,19.81,0Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M477.16,195.65a2.46,2.46,0,0,1-1.1-4.66l35.77-17.74L482,152.34a2.46,2.46,0,0,1,2.82-4L518,171.6a2.46,2.46,0,0,1-.32,4.22L478.25,195.4A2.51,2.51,0,0,1,477.16,195.65Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 477.16,
    cy: 193.2,
    r: 9.63,
    transform: "translate(205.32 627.84) rotate(-85.27)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-64",
    cx: 437.21,
    cy: 168.25,
    r: 6.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 483.44,
    cy: 150.32,
    r: 10,
    transform: "translate(-4.64 360.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M489.65,150.32a6.21,6.21,0,1,1-6.21-6.2A6.21,6.21,0,0,1,489.65,150.32Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 516.63,
    cy: 173.62,
    r: 13.3,
    transform: "translate(189.02 611.59) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M526,173.62a9.36,9.36,0,1,1-9.36-9.36A9.36,9.36,0,0,1,526,173.62Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-43",
    cx: 259.73,
    cy: 221.79,
    rx: 34.25,
    ry: 15.62,
    transform: "translate(-68.77 379.56) rotate(-72.84)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 260.54,
    cy: 221.79,
    rx: 34.25,
    ry: 15.62,
    transform: "translate(-68.2 380.34) rotate(-72.84)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M243,214.5V234H289.9V198.62h-31A15.88,15.88,0,0,0,243,214.5Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M274,214.5V234h31.76V214.5a15.88,15.88,0,1,0-31.76,0Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M304.54,232.71V214.5a14.64,14.64,0,0,0-28.12-5.7,14.44,14.44,0,0,0-1.15,5.7v18.21Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M322.67,232.71H274V234h48.65a.62.62,0,0,0,.62-.62h0A.62.62,0,0,0,322.67,232.71Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M243,214.5,242.57,234H274v-1.24h-7.25a17.88,17.88,0,0,1-17.87-17.88,21.4,21.4,0,0,1,1.56-8.53,12.78,12.78,0,0,1,8.44-7.68A15.88,15.88,0,0,0,243,214.5Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M263,198.62v19.16a1.23,1.23,0,0,1-1.24,1.24,1.25,1.25,0,0,1-1.25-1.24V198.62Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M266.54,218.37a3.17,3.17,0,1,1-3.17-3.17A3.17,3.17,0,0,1,266.54,218.37Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M266.88,218.37a3.17,3.17,0,1,1-3.17-3.17A3.17,3.17,0,0,1,266.88,218.37Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M280.56,181.85h-17.4a1.21,1.21,0,0,0-1.21,1.2h0v34.73A1.25,1.25,0,0,0,263.2,219h0a1.25,1.25,0,0,0,1.24-1.24V193.32h16.12a1.14,1.14,0,0,0,1.13-1.13V183A1.14,1.14,0,0,0,280.56,181.85Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M281.07,181.85h-17.4a1.2,1.2,0,0,0-1.2,1.2h0v34.73a1.24,1.24,0,0,0,1.24,1.24h0a1.25,1.25,0,0,0,1.25-1.24V193.32h16.11a1.14,1.14,0,0,0,1.14-1.13V183A1.14,1.14,0,0,0,281.07,181.85Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M274.45,191.85a5,5,0,0,1-2.46.55,4.1,4.1,0,0,1-4.18-4.3,5.05,5.05,0,0,1,5-5.3,3.83,3.83,0,0,1,4,4c0,2.07-1.16,3.28-2.45,3.28a1,1,0,0,1-1-1.21h-.06a2.17,2.17,0,0,1-1.94,1.21,1.57,1.57,0,0,1-1.49-1.74,3.26,3.26,0,0,1,3.26-3.27,3.73,3.73,0,0,1,1.48.29l-.47,2.5c-.21,1.05,0,1.53.42,1.54.7,0,1.48-.92,1.48-2.52a3.15,3.15,0,0,0-3.33-3.43c-2.25,0-4.14,1.77-4.14,4.57a3.44,3.44,0,0,0,3.54,3.73,4.42,4.42,0,0,0,2.09-.48Zm-.76-6a2.41,2.41,0,0,0-.69-.1,2.38,2.38,0,0,0-2.19,2.49c0,.6.3,1,.91,1,.8,0,1.53-1,1.68-1.87Z",
    transform: "translate(-39.95 -24.95)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M363.38,212.39l-5.86,20.44a1.51,1.51,0,0,1-1.88,1L321,224a1.54,1.54,0,0,1-1.05-1.89l5.86-20.43a1.54,1.54,0,0,1,1.89-1l.78.22,13.08,16.72,20-7.24.78.22A1.52,1.52,0,0,1,363.38,212.39Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "320.79 185.1 300.84 192.35 287.75 175.63 320.79 185.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M362.56,212.16,356.7,232.6a1.52,1.52,0,0,1-1.88,1l-34.6-9.92a1.51,1.51,0,0,1-1-1.88L325,201.4a1.52,1.52,0,0,1,1.89-1l.78.22,13.08,16.72,20-7.25.78.23A1.52,1.52,0,0,1,362.56,212.16Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M355.46,233.82,344.58,216.5a4.13,4.13,0,0,0-5.31-1.52l-18.41,8.93Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M354.82,233.64l-10.88-17.32a4.13,4.13,0,0,0-5.32-1.52l-18.4,8.92Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M362.16,210.46l-18.4,8.93a4.15,4.15,0,0,1-5.32-1.53l-10.88-17.32Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M361.52,210.28l-18.4,8.92a4.14,4.14,0,0,1-5.32-1.52l-10.88-17.32Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M371.85,228.16l-4.28-5a.39.39,0,0,0-.54,0h0a.39.39,0,0,0-.07.51l2.75,4-4-4.09a.41.41,0,0,0-.6,0h0a.41.41,0,0,0,0,.53l3.77,4.42-4.28-3.29a.39.39,0,0,0-.58.11h0a.4.4,0,0,0,.07.48l4.15,4-4.09-2.07a.39.39,0,0,0-.53.21h0a.38.38,0,0,0,.15.45l5.72,3.69,2.71-1.71Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M374.77,231.23l-.46-.34h0l-.75-1.28a3.06,3.06,0,0,0-2.66-1.61c-1.19,0-2.07.4-2.12,1.62a3.39,3.39,0,0,0,1.85,3.53l1.26.75h0l.88.91A11.77,11.77,0,0,1,374.77,231.23Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "376.84 222.06 352.58 219.43 349.41 225.48 374.48 230.85 379.17 228.79 376.84 222.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.42,255.86h0l-25.06-5.37a.08.08,0,0,1,0,0,0,0,0,0,1,0,0l3.17-6.06a.05.05,0,0,1,0,0L416.79,247a.05.05,0,0,1,0,0l2.32,6.74a.05.05,0,0,1,0,.07l-4.69,2.06Zm-25-5.47,25,5.35,4.62-2-2.29-6.66-24.19-2.62Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M408.63,245.62l-3.37,8.9s-1.78-.25-4.26-.68a85,85,0,0,1-11.25-2.61c-7.54-2.55-13-10.83-17.14-15.49a3,3,0,0,1,.07-.5c0-.11,0-.22.07-.33l0-.1a11.77,11.77,0,0,1,2-3.58l.07-.08.05-.07s.82.71,2.14,1.8a108.94,108.94,0,0,0,12.84,9.37,23.78,23.78,0,0,0,2.16,1.12c1.85.82,6.2,1.39,10,1.75C405.57,245.47,408.63,245.62,408.63,245.62Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M433.31,366.73l-1.64,1.75a1.79,1.79,0,0,0-.45,1.61l.17.85h9l0-.28a8.59,8.59,0,0,0-.8-5h0Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M403.46,240.5a5.12,5.12,0,0,0,3.7-.32l-1-5.41.32-2.17,2.13-.81,3.84,3.09.65,4.22a12,12,0,0,0,5.41-6.18c2.22-5.64-.37-11.4-5.43-12.65s-10,2.65-11.27,8.94C399.36,235.24,401.72,239.41,403.46,240.5Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M405.26,244.86l10.35-.53a21.6,21.6,0,0,1-.5-9.08,4.4,4.4,0,0,0-4.39-4.17h0a4.57,4.57,0,0,0-4.6,4.15A43.86,43.86,0,0,1,405.26,244.86Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M420.8,231.46c-.43,2.1-1.6,4.06-4.54,6.55a6.44,6.44,0,0,0-.43,2.29,2.47,2.47,0,0,1-2.07,2.37,7.4,7.4,0,0,1-3.05-.29,3,3,0,0,1-2.15-2.79c0-2.42.1-5.81-.94-7.19a1.51,1.51,0,0,0-.71-.55c-.77-.26-2.08,1.52-2.58,1.66l-.27-.2a1.13,1.13,0,0,1-.37-1.28c.44-1.16.95-3.64-.77-7.15.72-3.39,2.23-6.33,6.91-6.33a9.84,9.84,0,0,1,5,1.48h0a12.69,12.69,0,0,1,2.81,2.25l.51.48A9.56,9.56,0,0,1,420.8,231.46Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M407.65,234c-.37,1.27-1.43,2.07-2.37,1.8a2.16,2.16,0,0,1-1-2.79c.37-1.27,1.43-2.08,2.37-1.8a1.61,1.61,0,0,1,1.05,1.16.75.75,0,0,1,0,.16A3,3,0,0,1,407.65,234Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M405.71,235.47a1.12,1.12,0,0,1-.32,0,1.19,1.19,0,0,1-.53-.33.08.08,0,0,1,0-.11.07.07,0,0,1,.12,0,1.07,1.07,0,0,0,.45.28c.71.2,1.52-.42,1.8-1.39a2.22,2.22,0,0,0,0-1.14.53.53,0,0,0,0-.12,1.22,1.22,0,0,0-.79-.88l-.13,0s-.08-.05-.07-.09a.08.08,0,0,1,.1-.07.4.4,0,0,1,.15,0,1.37,1.37,0,0,1,.9,1,.65.65,0,0,1,0,.13,2.46,2.46,0,0,1-.05,1.23A2,2,0,0,1,405.71,235.47Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M416,245.66l-10.43-1.09s-6.08.92-8.29,5.21c-4.06,7.91-.76,16.52-1.79,29.66a20.86,20.86,0,0,1-.93,6.22h24.7l-2-5.12c.92-13.54,1.46-14.8,1.91-26.8C419.25,250,416,245.66,416,245.66Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M394.85,285.66h-.32S394.67,285.9,394.85,285.66Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.69,285.82h0a.3.3,0,0,1-.2-.13l-.05-.09H395l-.07.09A.25.25,0,0,1,394.69,285.82Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M380.57,364.78c-1.1,1.42-4.5,2.37-6.81,2.87a2.06,2.06,0,0,0-1.51,2.68l.2.61H388l.17-.81a9.15,9.15,0,0,0-.5-5.35h-7.06Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M439.91,365.7a7.12,7.12,0,0,1-3.46,1.23,14.55,14.55,0,0,1-4.19-.2c-.13-.62-.28-1.28-.45-2-3.56-14.38-14.47-39.5-14.47-39.5s-4.16-7-8.48-15.85l-.48-1c-1.85-3.83-3.7-7.95-5.24-11.95-.22-.59-.44-1.17-.65-1.76a61.26,61.26,0,0,1-2.64-9.08h19.38a70.59,70.59,0,0,1,3.21,8.2c.12.38.25.76.37,1.14,3.89,11.94,7.56,27.93,7.56,27.93a43.62,43.62,0,0,1,4.56,10.3C438.57,347.14,437.37,354.82,439.91,365.7Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M416.17,248.59s-2.12,1.2-2.92,1.5a39.83,39.83,0,0,1-4.26.83c-.15,0-3.44,1-7.67,1.64-1.36.22-2.83.4-4.31.52l-1.06.08c0-.1,0-.19.07-.29a16.26,16.26,0,0,1,.51-1.73,10,10,0,0,1,5.47-6h0l1.11-.55c4.91-2.3,10.75-1.52,12.31-1.25a.51.51,0,0,1,.42.47l0,.54.09,1.33Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M414.39,295c-.06.27-.13.53-.2.79l-.07.25c0,.14-.1.3-.16.48-.79,2.24-3.24,7.33-5.95,12.73-4.33,8.61-9.32,18-9.32,18a79.22,79.22,0,0,1-2.3,14.89c-2.38,10.14-5.65,21.14-7,23.32-1.57.78-8.78-.66-8.78-.66s.27-1.39.69-3.73c1.27-7.1,3.88-23,4.31-35.77,0,0,3-17.06,6.75-30.67.13-.49.27-1,.41-1.46.69-2.43,1.4-4.71,2.12-6.74l20.36-.75A37,37,0,0,1,414.39,295Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M423.33,293.58c-5.66,2-22.31,2.13-31.55-.71l-.09,0c0-.12.07-.25.11-.38.25-.84.51-1.81.75-2.89.48-2.1.94-4.64,1.32-7.58a143.18,143.18,0,0,0,1-21.88,19.83,19.83,0,0,1,.93-7.29,12.09,12.09,0,0,1,.75-1.68,10.47,10.47,0,0,1,5.48-4.83c3.21-1.31,7.73-1.67,14-.65a25.26,25.26,0,0,1,3.35,10c.23,3.21-.78,9.51-.09,18.33.14,1.77.35,3.63.65,5.59h0a79.45,79.45,0,0,0,2.07,9.54C422.36,290.59,422.82,292.07,423.33,293.58Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "350.81 247.96 349.41 249.37 333.21 267.59 337.38 270.18 355.18 254.41 356.01 251.8 350.81 247.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M371.37,295l-1.32,6.95a.41.41,0,0,0,.32.48h0a.41.41,0,0,0,.49-.28l1.37-4.5-.9,4.94a.44.44,0,0,0,.3.5h0a.44.44,0,0,0,.56-.3l1.35-4.87-.77,4.51a.39.39,0,0,0,.32.45h0a.4.4,0,0,0,.46-.28l1.28-4.41-.73,4a.37.37,0,0,0,.29.41h0a.35.35,0,0,0,.39-.23l2-5.43-2.23-.83Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M373.16,292.54l-1.48,1.83a1.59,1.59,0,0,0-.23,1.65h0a3.37,3.37,0,0,0,3.67,2h0a2.49,2.49,0,0,0,2-1.9l.22-1Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M406,257.28c-1.71,5.07-7.3,19-11.84,24.43a82.35,82.35,0,0,1-9.58,9c-2.81,2.34-5,4-5,4s-.19-.09-.51-.28a9.81,9.81,0,0,1-4-4.47l-.08-.18c2.39-3.8,13.27-14.59,14.47-16.52,4.07-6.54,4.66-22.22,10.74-25.56h0a5.65,5.65,0,0,1,4.58-.3,2.52,2.52,0,0,1,1.38,1.18C407.07,250.33,407.22,253.55,406,257.28Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M373.83,230.06a10.55,10.55,0,0,1,.34-4.73.27.27,0,0,0-.11-.31h0a.73.73,0,0,0-1,.27,9.48,9.48,0,0,0-1.23,3.35C371.84,230.67,373.83,230.06,373.83,230.06Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M414.39,295c-.08.35-.17.7-.27,1,0,.14-.1.3-.16.48a63.09,63.09,0,0,1-10.82,0,56.94,56.94,0,0,1-10.82-1.89c.13-.49.27-1,.41-1.46a56.53,56.53,0,0,0,9.76,1.59A86.92,86.92,0,0,0,414.39,295Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M422.81,295c-.12-.38-.25-.76-.37-1.14a39.72,39.72,0,0,1-8.05,1.09c-.08.35-.17.7-.27,1,0,.14-.1.3-.16.48-.76,2.14-3,6.86-5.58,12l.48,1c1.36-1.84,6.23-8.6,7.78-13.26A57.94,57.94,0,0,0,422.81,295Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M423.33,293.58c-5.66,2-22.31,2.13-31.55-.71l-.09,0c0-.12.07-.25.11-.38.25-.84.51-1.81.75-2.89.48-2.1.94-4.64,1.32-7.58l.24-.28c4.54-5.44,10.13-19.36,11.84-24.43,1.26-3.73,1.12-6.95.11-8.64.12.15,2.92,4,0,11.91-1.83,5-5,12-7.19,16.67a29,29,0,0,0-2.68,10.62h0a5.16,5.16,0,0,0,4.24,5.36A73.79,73.79,0,0,0,423.33,293.58Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M379,294.48l-.67.58a6.86,6.86,0,0,1-4-4.43L375,290A9.81,9.81,0,0,0,379,294.48Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M374.84,231.15l-.07.08a11.77,11.77,0,0,0-2,3.58c0,.14-.07.29-.1.43l-1-1.16c.21-1.38,2.48-3.78,2.48-3.78Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M398.69,327.23a79.22,79.22,0,0,1-2.3,14.89c-2.38,10.14-5.65,21.14-7,23.32-1.57.78-8.78-.66-8.78-.66s.27-1.39.69-3.73C390.32,363.57,398.69,327.23,398.69,327.23Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M439.91,365.7a7.12,7.12,0,0,1-3.46,1.23,14.55,14.55,0,0,1-4.19-.2c-.13-.62-.28-1.28-.45-2,12.36.11-1.44-41.85-1.44-41.85a43.62,43.62,0,0,1,4.56,10.3C438.57,347.14,437.37,354.82,439.91,365.7Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M406,257.28c-1.71,5.07-7.3,19-11.84,24.43a82.35,82.35,0,0,1-9.58,9c-2.81,2.34-5,4-5,4s-.19-.09-.51-.28c11.17-9.44,24.13-32.56,25.55-40.3s-4.27-6.47-4.45-6.43a5.65,5.65,0,0,1,4.58-.3,2.52,2.52,0,0,1,1.38,1.18C407.07,250.33,407.22,253.55,406,257.28Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M402,245.12a10,10,0,0,0-5.47,6,12.09,12.09,0,0,0-.75,1.68,56.87,56.87,0,0,1-6-1.59c-7.54-2.55-13-10.83-17.14-15.49a3,3,0,0,1,.07-.5c0-.11,0-.22.07-.33a52.86,52.86,0,0,0,14.58,12.62,10,10,0,0,0,10.24-.3A19.93,19.93,0,0,1,402,245.12Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M419.88,279.61h0s-3.55,4-17.88,3c16.39.35,17.21-8.32,17.23-8.55C419.37,275.79,419.58,277.65,419.88,279.61Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M420.8,231.46c-.43,2.1-1.6,4.06-4.54,6.55a6.44,6.44,0,0,0-.43,2.29,2.47,2.47,0,0,1-2.07,2.37,7.4,7.4,0,0,1-3.05-.29,3,3,0,0,1-2.15-2.79c0-2.35.09-5.61-.85-7.06a.75.75,0,0,0,0-.16c2.83,1.58,5.08,6.7,9.66,1.13,5.46-6.64-2.38-13.31-2.53-13.46a12.69,12.69,0,0,1,2.81,2.25l.51.48A9.56,9.56,0,0,1,420.8,231.46Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M167.39,150.21l0,32.85a2.35,2.35,0,0,1-2.36,2.35l-55.63-.07A2.35,2.35,0,0,1,107,183l0-32.86a2.36,2.36,0,0,1,2.36-2.35h1.25l26.54,19.3,26.59-19.23H165A2.36,2.36,0,0,1,167.39,150.21Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "122.53 122.9 95.94 142.13 69.4 122.83 122.53 122.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M166.07,150.2l0,32.86a2.35,2.35,0,0,1-2.36,2.35l-55.62-.07a2.36,2.36,0,0,1-2.36-2.36l0-32.85a2.34,2.34,0,0,1,2.35-2.35h1.26l26.53,19.3,26.59-19.24h1.25A2.34,2.34,0,0,1,166.07,150.2Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M164.71,185.41,141.2,164.29a6.41,6.41,0,0,0-8.55,0l-23.57,21.07Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M163.67,185.41l-23.51-21.13a6.42,6.42,0,0,0-8.55,0l-23.56,21.07Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M164.76,147.85l-23.57,21.07a6.42,6.42,0,0,1-8.55,0l-23.51-21.13Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M163.72,147.85l-23.56,21.07a6.41,6.41,0,0,1-8.55,0l-23.52-21.12Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M652.38,245.38v19.37h-46.7V229.56h30.88A15.83,15.83,0,0,1,652.38,245.38Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M621.5,245.38v19.37H589.86V245.38a15.82,15.82,0,0,1,31.64,0Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M620.26,245.37v18.14H591.1V245.37a11,11,0,0,1,.09-1.52,3.19,3.19,0,0,1,.08-.62,14.13,14.13,0,0,1,1-3.53,14.89,14.89,0,0,1,1.79-3.09l.49-.62c.27-.32.55-.62.85-.92a14.55,14.55,0,0,1,20.62,0c.3.3.58.6.85.92l.49.62a14.89,14.89,0,0,1,1.79,3.09,14.15,14.15,0,0,1,1,3.53,4.2,4.2,0,0,1,.07.62A11,11,0,0,1,620.26,245.37Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M652.38,245.38l.44,19.37H621.5v-1.24h7.22a17.8,17.8,0,0,0,17.8-17.8,21.47,21.47,0,0,0-1.55-8.5,12.77,12.77,0,0,0-8.41-7.65A15.83,15.83,0,0,1,652.38,245.38Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M632.44,229.56v19.08a1.24,1.24,0,1,0,2.48,0V229.56Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M629,249.23a3.16,3.16,0,1,0,3.15-3.16A3.15,3.15,0,0,0,629,249.23Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M628.61,249.23a3.16,3.16,0,1,0,3.15-3.16A3.15,3.15,0,0,0,628.61,249.23Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M615,212.86h17.33a1.2,1.2,0,0,1,1.2,1.2h0v34.58a1.24,1.24,0,0,1-1.24,1.24h0a1.23,1.23,0,0,1-1.24-1.24V224.29H615a1.13,1.13,0,0,1-1.13-1.13V214A1.13,1.13,0,0,1,615,212.86Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M614.47,212.86H631.8a1.21,1.21,0,0,1,1.21,1.2h0v34.58a1.24,1.24,0,0,1-1.25,1.24h0a1.24,1.24,0,0,1-1.24-1.24V224.29h-16a1.14,1.14,0,0,1-1.13-1.13V214A1.14,1.14,0,0,1,614.47,212.86Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M625.28,222.82a5,5,0,0,1-2.45.55,4.09,4.09,0,0,1-4.16-4.29,5,5,0,0,1,5-5.27,3.81,3.81,0,0,1,4,4c0,2.06-1.15,3.27-2.45,3.27a1,1,0,0,1-1-1.21h-.06a2.15,2.15,0,0,1-1.93,1.21,1.56,1.56,0,0,1-1.49-1.73,3.25,3.25,0,0,1,3.26-3.26,3.55,3.55,0,0,1,1.47.29l-.47,2.49c-.2,1,0,1.52.41,1.53.7,0,1.49-.92,1.49-2.51a3.15,3.15,0,0,0-3.33-3.42c-2.24,0-4.12,1.77-4.12,4.56a3.43,3.43,0,0,0,3.53,3.71,4.29,4.29,0,0,0,2.08-.48Zm-.76-5.93a2.09,2.09,0,0,0-.69-.1,2.36,2.36,0,0,0-2.18,2.47c0,.61.3,1.05.91,1.05.79,0,1.52-1,1.67-1.87Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 551.15,
    y: 232.75,
    width: 29.16,
    height: 0.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 551.15,
    y: 225.51,
    width: 29.16,
    height: 0.63
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M620.17,243.85h-29a3.19,3.19,0,0,1,.08-.62H620.1A4.2,4.2,0,0,1,620.17,243.85Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M617.33,236.61H594l.49-.62h22.32Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-51",
    cx: 564.93,
    cy: 218.83,
    rx: 2.28,
    ry: 3.13
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-74",
    cx: 564.4,
    cy: 218.83,
    rx: 2.28,
    ry: 3.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M620.26,245.37v18.14h-3.6V245.37a11,11,0,0,0-.09-1.52,3.19,3.19,0,0,0-.08-.62,13.74,13.74,0,0,0-1-3.53,14,14,0,0,0-1.79-3.09c-.15-.21-.32-.42-.48-.62s-.55-.62-.85-.92a14.62,14.62,0,0,0-4.64-3.13,14.43,14.43,0,0,0-3.88-1,11.92,11.92,0,0,1,1.8-.12A14.45,14.45,0,0,1,616,235.07c.3.3.58.6.85.92l.49.62a14.89,14.89,0,0,1,1.79,3.09,14.15,14.15,0,0,1,1,3.53,4.2,4.2,0,0,1,.07.62A11,11,0,0,1,620.26,245.37Z",
    transform: "translate(-39.95 -24.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 576.52,
    y: 239.79,
    width: 6.31,
    height: 85.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 582.82,
    y: 239.79,
    width: 1.65,
    height: 85.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 576.52,
    y: 239.8,
    width: 6.31,
    height: 1.53
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesC);
export default __webpack_public_path__ + "static/media/sales-c.5c06fbd7de889f7d238a5b04c7a3ca71.svg";
export { ForwardRef as ReactComponent };